import Vue from 'vue'
import Vuex from 'vuex'
//import firebase from 'firebase'
import router from '@/router'

var CryptoJS = require("crypto-js");
const fb = require('../firebaseConfig.js');
var moment = require('moment');


Vue.use(Vuex)
window.endpoint = String(process.env.API_URL);
window.apiendpoint = String(process.env.API_ENDPOINT_URL);
window.socketendpoint = String(process.env.SOCKET_URL);
window.devendpoint = String(process.env.DEV_API_URL);

export const store = new Vuex.Store({
  state: {
	 //subscription
	 convsubscription:{},
	 contactviewtype:'eventlogs',
	 contactviewsubtype:'transactions',
	 
	 //site
	 selectloading:false,
	 sitedata:[],
	 sitedatalength:0,
	 
	 //usage
	 usageid:'home',
	 usagetype:'all',
	 usageproj:null,
	 searchaccount:'',
	 stripeauthfullresult:[],
	 
	 //db
	 newcurrentlogo:{ uid:null,label: '',dbname:'',description:'', status:0 ,privileges:[],subaccountid:null,subaccountemail:'',type:'database',tablename:'All',table_list_id:0 },
	 
	 //events
	 selectedevent:{},
	 projectmenu:[],
	 contactmenu:[],
	 calendarlist:[],
	 calevents:[],
	 //LeftMenu
	 cmsmenu:[],
	 dbmenu:[],
	 
	 
	 dirList:[],
	 disdata:[],
	 resMap:[],
	 e1:1,
	 
	 //chat
	 chatname:'',
	 chroom:'',
	 chuser: {},
	 chmessages: [],
	 chusers: [],
	 
	 //chat2
	 pjroom:'',
	 pjuser: {},
	 pjmessages: [],
	 pjusers: [],
	 
	 //one2
	 oroom:'',
	 ouser: {},
	 omessages: [],
	 ousers: [],
	 
	 //chat2
	 cmsroom:'',
	 cmsuser: {},
	 cmsmessages: [],
	 cmsusers: [],
	
	
	//create table
	 incoming:false,
	 inconn:null,
	 acceptcall:false,
	 log: 'Connecting...',
	 kdata:[],
	 openphone:false,
	 indeterminate:false,
	tableinfo:{ uid:null,name:'',description:'', status:1 ,table_template_id:1,table_templates:{},   tablename:'', userdatabase_id:'', project_id:'',fields:[]},  
	tabledatatype:[
		{"name":"Integer","value":"int"},
		{"name":"Character","value":"VARCHAR"},
		{"name":"Text","value":"text"},
		{"name":"Json","value":"json"},
		{"name":"Boolean","value":"boolean"},
		{"name":"Timestamp","value":"timestamp DEFAULT CURRENT_TIMESTAMP"}
	],
	groupentityModel: false,
	groupentitytable:{ uid:null,name:'',description:'', status:1 ,table_template_id:1,table_templates:{},   tablename:'', userdatabase_id:'', project_id:'',fields:[]},		 
	currentlogo:{ uid:null,name:'',description:'', status:1 ,table_template_id:1,table_templates:{},   tablename:'', userdatabase_id:'', project_id:'',fields:[]},
	templatetype:'None',
			 
	//Drive files
	drivelist:[],
	syncdate : "",
	outlooksyncdate:"",
	fileslist:[],
	onedrivelist:[],
	drivetype:{type:'',pagelength:1,pagecount:10,datalength:0},
	groupsModel: false,
	projectuid :'',
	alexadeviceid:'',
	alexadevices :[],
	devicetype:'googlehome',
	distoken : '',
	dirId:'',
	dirName:'',
	addMediaFile: false,
	addMediaItem: { status: '1'},
	createDir : false,
	jsonPreview: false,
	fileId : '',
	fileLink:'',
	fileName: '',
	listFileItem : [],
	listFileContent : [],
	saveKeyword: '',
	jsonkeyword : '',
	listFileCount:'',
	disemail:'',
	disapikey:'',
	 
	newuser: false,
	uservalidation: '',
	
	msginput:'',
	planlists: [],
	plan: null,
	selectedplan:1,
	timer: '',
	
	deviceres:[],
	gdevicelogssel:{id:''},
	seltodolist:{},
	seldevicetab:'',
	seldeviceid:'',
	selformid:null,
	formsubname:'lists',
	currentformdata:{title:'Untitled form',body:'form description',questions:[]},
	formdata:[],
	currentquestiondata:[],
	questiondata:[],
	
	 devicename :'googlehome',
	recentmsg:[],//home page
	selectednumber:{},
	selprojectid:null,
	selprojectdata:{},
	projectlist:[],
	selsubprojectid:null,
	subprojectlist:[],
	
	
	serviceadddialogue:false,
	serviceaddwizard:1,
	serviceaddwizardeditable:true,
	teamadddialogue:false,
	teamaddwizard:1,
	teamaddwizardeditable:true,
	pageloading: false,
    appTitle: 'Abitswift',
    user: null,
    userProfileInfo: null,//Profile Page Edit
    error: null,
    loading: false,
    listloading: false,
    tasklistloading: false,
    workerlistloading: false,
    remainder: [],
    templatelabel: [],
    templatemessages: [],
    snack : false,
    snackColor : 'info',
    snackText : 'Info Message',
    adddialog: false,
    addtmpdialog: false,
    addsbdialog: false,
	activeTab:"0",
	addworkersdialog:false,
	addwsdialog:false,
	workspaces: [], //All workspacelist
	workspacesid: '', //Selected Active 
	workspacesdata: {friendlyName:'',workflows:[],workers:[],activities:[],taskqueues:[],taskchannels:[],tasks:[]}, //Selected Active workspace full details with list
	currentworkspace: {workercount:0,workspace:{ workspacename: '',wscontactmode: ['sms','voice'],wsworkers: 2,wsSid:'',mobileno:'',},workers:[],workflows:[],activities:[],taskqueues:[],taskchannels:[],tasks:[]}, //Selected Active workspace full details with list
	wstasklist:[],
	wsworkerlist:[],
	subworkerlist:[],
	//offered services
	offered_service:{"description": "","name": "","pricing": {"currency": "USD","price": "","type": "Full Cost"},"servicetype": "Standard"},
	
	selectphone:{},
	tomenuid:'',
	tomenutype:'',
	availableNumbers:[],
	phonenumberlist: [], //Searched availanle Pvt Number  to Buy
	phonenumbersearchload: false, //Load on Searching
	privateNumbers: { List: [] , NumberDetails : [] , ownerAccountSid: null , clientsid : null , authToken : null ,selected: '', defaultnumber: '',status:0 },
	subacc: {   firstname:'',lastname:'',   emailaddress:'',   password:'',   phonenumber:'',   status:1, countryCode: '91',country:'India',countryCodeimg: 'in',previleges: [ {name:'reminder',label:'Reminder',access:true}, {name: 'taskrouting',label:'Call Routing',access:true} ]  , invitestatus:0, confirmationstatus:0 , err:'', country:'India' },
	
	inchatlogs: [],				
	listsubaccount: [],				
	addgroupdialog: false,
	mapviewdialog: false,
	contacts: [],
	listcontacts: [],
	groups: [],
	groupcontacts: [],
	selectedGroups:[],
	activityloghistory: [],
	activitylogtype: null,
	selectedcontactEvent: { title : '' },
	addcontact:{ firstname: '',lastname: '',email: '',phone: '',privatenumberSid:'',acc_status:1,status: 1,id: null,address:'',favorite_status: 0,lat:null ,lng: null,countryCode: '91', 	countryCodeimg: 'in',country:'India',birthday: null,notes: null,keywords: null,company: null,jobtitle:null,phonelists: [{pref:false,phone:'',country:{ name: 'United States', cc: '1', code: 'us' },label:'Home',privatenumberSid:''},{pref:false,phone:'',country:{ name: 'United States', cc: '1', code: 'us' },label:'Home',privatenumberSid:''}], emaillists: [{email:'',label:'Home'},{email:'',label:'Home'}], addresslists: [{streetaddress2:'',city:'',state:'',pincode:'',label:'Home',address:''}],customfield: [{value:null,type:null}],customdate: [{value:null,type:null,menu: false}],contacttype:{ id: "1",name: "Default" },category:'People',objecttypes:'People',objectsubtypes:'Default',business:[{name:'',title:'',start: '',end: '',description:''}],experience:[{name:'',title:'',start: '',end: '',description:''}],skillset:[{name:'',year:'0',expertlevel:'Beginner'}],groupids:[],groupname:[] },
	
	addobjecttypedialog: false,
    addroledialog: false,
	objectTypes:[],
	contact_roles:[],
	datalength:0,

	//Defaultphonelists: [],
	Defaultphonelists: {pref:false,phone:'',country:{ name: 'United States', cc: '1', code: 'us' },label:'Home',privatenumberSid:''},
	ProfileSelectedFile: '',
	editablestepper: false,
	editable_el: 1, //Default step 1
	contactsearchfilter: false,
	contactfiltertype: 'all',
	searchtxtInput: '',
	contactselectsearch_items: [],
	addquickcontactdialog: false,
	
	
	gMapsearchAddressInput: '', //googleMap
	gMapsearchAddressResult: null, //googleMap Full address details
	gMapcoordinates: { lat: null, lng: null} ,
	gMapmarkers: [] ,
	//gMapcenter: { lat: 45.508, lng: -73.587 } ,
	gMapcenter: { lat: null, lng: null } ,
	gMapzoom: 16 ,
	
	choosepvtindex: 0,
	choosepvtdialog: false,
    addpvtdialog: false,
	pvtloading: false,
	//selectedpvtno: {},
	//callfwd: { sid:'', primaryno:'', meetingdetails:'', ForwardTo:'Yes', ForwardTodata:'', Dmsg:'Yes', Dmsgdata:'Your Call Forwarding to +91 9790120413 Please hold on your call' },
	callfwd: { sid:'', primaryno:'', meetingdetails:'', ForwardTo:true, ForwardTodata:'', Dmsg:true, Dmsgdata:'Your Call Forwarding to +91 9790120413 Please hold on your call' ,ForwardVoice:true }, 
	listCallfwd: [],
	callfwddialogue:false,
	Taskperformance: {utilized_totalmin:0,workspace:[]}, //Dashboard Task performance
	business: { //Team
	  id:null,
	  name: 'Abitswift Development',
	  phoneNumber: '6193892811',
	  select: 'Johnson',
	  address2: 'Pannaikadu',
	  keywords: 'marketing,business,customercare,helpline',
	  notes: '24X7 Customer Care Support', 
	  bhours:"1", 
	  btiming:"1" ,
	  //bdays:[ "Mon","Tue","Wed","Thu","Fri","Sat","Sun"] ,
	  custom:[ 
		  {start:24,end:24 ,text:'Monday' ,val:'Mon' },
		  {start:24,end:24 ,text:'Tuesday'  ,val:'Tue'},
		  {start:24,end:24 ,text:'Wednesday'  ,val:'Wed'},
		  {start:24,end:24 ,text:'Thursday'  ,val:'Thu'},
		  {start:24,end:24 ,text:'Friday'  ,val:'Fri'},
		  {start:24,end:24 ,text:'Saturday'  ,val:'Sat'},
		  {start:24,end:24 ,text:'Sunday'  ,val:'Sun'}
		  ],
	  sameday:{start:24,end:24 ,text:'Same' },
	  samedayarray:[ 	
				{ "val":"Sun","sval":"S","text":"Sunday","id":"7"}, 
				{ "val":"Mon","sval":"M","text":"Monday","id":"1"},
				{ "val":"Tue","sval":"T","text":"Tuesday","id":"2"},
				{ "val":"Wed","sval":"W","text":"Wednesday","id":"3"},
				{ "val":"Thu","sval":"T","text":"Thurday","id":"4"},
				{ "val":"Fri","sval":"F","text":"Friday","id":"5"},
				{ "val":"Sat","sval":"S","text":"Saturday","id":"6"},
			],
	  members:[]
	  } ,
	  knowledgelist:[],
	  knowledge: { //Services
		  id:null,
		  name: '',
		  type: '',
		  programlength:1,
		  keywords: '',
		  notes: '24X7 Customer Care Supportss', 
		  service:"1",  //knowledge/information/standard
		  serviceoption:"1" , //private/public
		  servicemethod:"2", //sms/email/voicecall
		  servicecontent:"1", //audio/video/voice
		  samedayarray:[], 
		  servicealerts:[],
		  category: '0',
		  subcategory: '0',
		  sublevelcategory: '0',
		  } ,
	  //Portfolio
	  addportdialog: false,
	  addportitem: {	title:'',external_link: '',blog_description:'',source:'image' ,file: '', featured: '0'	},
	  addportfiles: [],
	  portfolioList: [],
	  
	  //Business Profile
	  businessProfileSelectedForce: false,
	  businessProfileSelected: '',
	  businessProfileInfoList: [],
	  businessProfileInfo:{ 
		alerts: {
			excludedates: [],
			holidaydates: [],
			privatenumber: {},
			notificationtype: [ 'sms'],
			notifyon : 900
		},
		daysettings: {
			bhours: "3",
			btiming: "2",
			sameday: {start:24,end:24  },
			samedayarray:[ 	
					{ "val":"Sun","sval":"S","text":"Sunday","id":"0"}, 
					{ "val":"Mon","sval":"M","text":"Monday","id":"1"},
					{ "val":"Tue","sval":"T","text":"Tuesday","id":"2"},
					{ "val":"Wed","sval":"W","text":"Wednesday","id":"3"},
					{ "val":"Thu","sval":"T","text":"Thurday","id":"4"},
					{ "val":"Fri","sval":"F","text":"Friday","id":"5"},
					{ "val":"Sat","sval":"S","text":"Saturday","id":"6"},
				],
			custom:	[ 
			  {start:24,end:24 ,text:'Sunday',val:'Sun',sval:'S',id:'0'},
			  {start:24,end:24 ,text:'Monday',val:'Mon',sval:'M',id:'1'},
			  {start:24,end:24 ,text:'Tuesday',val:'Tue',sval:'T',id:'2'},
			  {start:24,end:24 ,text:'Wednesday',val:'Wed',sval:'W',id:'3'},
			  {start:24,end:24 ,text:'Thursday',val:'Thu',sval:'T',id:'4'},
			  {start:24,end:24 ,text:'Friday',val:'Fri',sval:'F',id:'5'},
			  {start:24,end:24 ,text:'Saturday',val:'Sat',sval:'S',id:'6'}
			  ],
			} 
		},
	  BProfileSelectedFile:'',
	  alertsevents:[],
	  alertlist:[],
	  addalertsdialog:false,
	  addalerts: {
				id: '', 
				status: 1, 
				content: '',
				type: '',
				title: '',
				start: '',
				time: '',
				end: '',
				moreparticipants: false,
				repeatdays: 0,
				minimummeetinglength: 60,
			  },		   
	  
	  
	  events: [],	   		  
	  selectedEvent: {},	
	  selecteddayClick: new Date().toISOString().substr(0, 10),	 
	  selectedeventClick: '',	  
	  selectedpanel: [], 
	  //endselecteddayClick: new Date().toISOString().substr(0, 10),	  
	  endselecteddayClick: '',	  
	  editactiondialog:false,   		  
	  editmeetingdialog:false,   		  
	  editmeeting:{}, 
	  eventfiles: [],  
	  editmeetingdialog2:false,		  
	  editmeetingdialog3:false,		  
	  addmeetingdialog:false,		  
	  addmeetingdialog_Step:1,	
	  notify_beforeon: [
			{ "val": 900 ,"text": "15 Min"},
			{ "val": 1800 ,"text": "30 Min"},
			{ "val": 3600 ,"text": "1 hour"},
			{ "val": 7200 ,"text": "2 hour"},
			{ "val": 14400 ,"text": "4 hour"},
			{ "val": 28800 ,"text": "8 hour"},
			{ "val": 43200 ,"text": "12 hour"},
			{ "val": 86400 ,"text": "24 hour"},
			{ "val": 172800 ,"text": "2 days"},
			{ "val": 259200 ,"text": "3 days"},
			{ "val": 864000 ,"text": "10 days"}
		],	  
	  
	  //Questions 
	  questions: [],
	  questionresponse: [],
	  twilioresponse: [],
	  listimages: [],
	  
	  //Database
	  dblist:[],
	  selecteddb:null,
	  selecteddblist:{},
	  dbadddialogue:false,
	  selsubmenu:'browse',
	  dbuseradddialogue:false,
	  detailsmenu:'',
	  
	   tableleft:true,
	   tabledata:[],
	   tableid:null,
	   tablesel:{},
	   tabledetails:[],
	   
	   listforms:[],
	   examformid:'',
	   exam:{ uid:null,title:'Vuejs Test',description:'',  abitform_id:null, status:1,teamlist:[]},
	   examlist:[],
	   examresponses:[],
	   coursetype:'toc',
	  
	   //Action
	   addquickactiondialog: false,
	   listactions: [],
	   addaction: { name: '',description: '',status: 1,id: null,uid: null  },
   
	  //Blogs	  
	  addblogurldialog: false,
	  previewdialog: false,
	  addblogdialog: false,
	  addstoragedialog: false,
	  getstoragefilepopup: false,
	  //bloglisting or codebook
	  addblogitem: {trigger:'',triggeroperations:'',importscode:[],	blog_type: 'bloglisting', title:'',blog_description:'',blog_panel: [{ panel: '' }],code_panel:[{ importscode: {}, filename: '', action: '', codetype: 'description', description: '',command:'',filestypearray:{},filecontent:'',tmpfiles:[],type:'add'}] ,triggeroperation: '', triggerinfo: '',file: '', featured: 'predefined',category:'General', metadata: [],abitcmssite_id:null,abitcmssitecategory_id:null},				
	  //addblogitem: {	title:'',blog_description:'',blog_panel: [{ panel: '' }] ,file: '', featured: 'predefined', metadata: []},
	  addstorageitem: { status: '1'},
	  addblogfiles: [],
	  addblogcodefiles: [],
	  codebookList: [],
	  addjupyterfiles: [ ],
	  jupyterList: [],
	  addquickappsdialog: false,
	  AuthKeyList: [],
	  addAuthKeyList: { id: '', status: 1, uid: '', username: '' , project_id: '', private_key_id: '',client_email: '', client_id: '', filecontent: '', apps_platform:{},apps_platform_id:'',apps_platform : '', name:'',keyname : '', icon : ''  },
	  
	  //Email Config
	  EmailAccountList:[],
	  allgmailmessages:[],
	  sentgmailmessages:[],
	  
	  
	  EntViewslist: [],
	  addquickentitygroupdialog: false,
	  addentitygroup: { name: '',groupentityid:'',description: '',status: 1,id: null,uid: null  },
	  selectedEntityList: [],
	  EntityList: [],
	  EntityListfilters: [],
	  addentity: {status: 1, uid: '', username: '' , entityname: '', entities: [  { value: '', synonyms: [] } ]  },				 
	  addcodebook: {filecontent: '',filename: '',filetype: '',filepath: '',path:'',filestypearray: {},lastedit_username: '',mimetype: 'text/javascript',uid: '',username: '' ,triggeroperation: '', triggerinfo: '' },
	  addtrackingtermsdialog: false,
	  TTTableslist: [],
	  listtrackingterms: [],
	  listtrackingtermsfilters: [],
	  addtrackingtermsParents: [],	
	  addtrackingterms: { objecttype:'People', objecttype_id:6, trackingid: '', parent_id: 0, level: 1,entityname: '',entitybook_id:'', name: '',synonyms: '',example: '',typedefine_id: 9,status: 1,id: null,uid: null  },	
	  viewtrackingterms: { objecttype:'People', objecttype_id:6, trackingid: '', parent_id: 0, level: 1,entityname: '',entitybook_id:'', name: '',synonyms: '',example: '',typedefine_id: 9,status: 1,id: null,uid: null  },	
	  selectedtrackingterms:[],
	  seltrackingterms:null,
	  addquickttgroupdialog: false,
	  addttgroup: { name: '',grouptrackingid:'',description: '',status: 1,id: null,uid: null  },
	  TTGroupsselected: [],
	  TTGroupslist: [],
	  Platformlist: [],
	  selentity:null,  
	  blogList: [],
	  commentList: [],
	  CategoryList: [],
	  SelCategoryList: [],
	  SubCategoryList: [],
	  SubcategoryListSel: [],
	  StorageList: [],
	  StorageSelectnameList: [],
	  editorContent: [ "" ],
	  
	  objectstypeitems: [
	  {icon:'sort',name:'Single line text',type:'singleline',"structure": { "column_name":"name","data_type":"VARCHAR","max_length":100}}, 
	  {icon:'subject',name:'Paragraph',type:'paragraph',"structure": { "column_name":"name","data_type":"VARCHAR","max_length":100}}, 
	  {icon:'pin',name:'Number',type:'number',"structure": { "column_name":"name","data_type":"int","max_length":12}},
	  {icon:'date_range',name:'Date and Time',type:'datetime',"structure": { "column_name":"name","data_type":"timestamp DEFAULT CURRENT_TIMESTAMP","max_length":100}}, 
	  {icon:'check_circle',name:'Boolean',type:'boolean',"structure": { "column_name":"name","data_type":"boolean","max_length":100}}, 
	  {icon:'check_box',name:'Checkbox',type:'checkbox',"structure": { "column_name":"name","data_type":"VARCHAR","max_length":100}, typearray: []}, 
	  {icon:'radio_button_checked',name:'Radiobutton',type:'radio',"structure": { "column_name":"name","data_type":"VARCHAR","max_length":100},typevalue:''},  
	  {icon:'sell',name:'Tags',type:'tag',"structure": { "column_name":"name","data_type":"VARCHAR","max_length":100}}, 
	  {icon:'line_style',name:'Enumeration',type:'enum',"structure": { "column_name":"name","data_type":"VARCHAR","max_length":100}}],
	  objectsadditem : {  project_id:'', cms_id:'',status: 1, keywords: '', title:'',description:'',fields:[{"value": {icon:'sort',name:'Single line text',type:'singleline',"structure": { "column_name":"name","data_type":"VARCHAR","max_length":100}} ,"status":1, "fieldname":"","type":'singleline','data_type':'','required':''}]},
	  selectedobjectsadditem:{},
	selectedOMmodel:[],
	  productList:[],
	  ObjectmodelList:[],
	  ObjectmodelLength:10,
	  
	  TemplateblogList: [],
	  PickedBlog: null,
	  addquickblogdialog: false,
	  	
	  MEMOMCategoryList: [],
	  MEMOMSubCategoryList: [],
	  //Collections
	  collectionsadddialogue:false,
	  collectionssongsdialogue:false,
	  collections: [],
	  currentcollections: [{categorynew:{},subcategorynew :{}}],
	  collectionsongs: [],
	  currentcollectionsongs:[],
	  
	  //Reminder
	  addremaindertitle: 'add',
	  addremainder : {
		  type:'Daily',title: '',notes:'', src: 'https://cdn.vuetifyjs.com/images/cards/house.jpg', flex: 3 , date: null, time: null ,status: 1,platform:'webapp',notificationtype:'sms',notificationstatus:1,calltype:'text',callmessagetext:'',callmessagetone:'',repeat:null,repeaton: ["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],retries:0,delay:0,occurrence: 5,defaultmessage: [{message:'',date:'',time: ''}],template: [ ] },
	  notificationlist:[],
	  
	  //Amp Story
	  coverpage: { id: '', title: '',title_animation: '', subtitle: '', subtitle_animation: '', description: '', description_animation: '' },
	  endpage: { facebook: false, twitter: false, pinterest:false, insta:false, facebookurl:'', twitterurl:'', pinteresturl:'', instaurl:''  },
	  coverfiles: [],
	  storypagefiles: [],
	  StoriesList: [],
	  storypage_elements: {
            data :[
                {	page:1,
					layoutcount: 1,
                    layout:[
                        {title:'',description:'',t_anim:'',d_anim:'',image:'',audio:'',video:'',mediatypes:['Image','Image with Audio','Video'],media:'Image'}
                    ]
                }
            ]
        },
	 aplayerlist: [],
	 aplayerlistcurrent:{},
	 vplayerlist: [],
	 vplayerlistcurrent:{},
	 collectionfavsongs: [],
	 iplayerlist:[],
	 
	    //voip
		sactive:null,
		confsadddialogue:false,
		conflist:[],
		selconflist:{ id:'',  opencalldate: new Date().toISOString().substr(0, 10) , opencall:'Yes',location:'Yes',seatLtd:'Yes',passPro:'Yes',recordConf:'No',sendUrl:'No',phonenumbers:'+918508430849,+916379112113'},
		selconflistid:'',
		confparticipant:[],
		confparticipantid:'',
		schedulevoip:{id : '',title:'', sameday:{method:'Endless',start1:null,end1:null  ,menu1: false,menu2: false,mtype1:'menu1',mtype2:'menu2'}},
		voipevents:[],
		
	 //Pages
	 addpageitem: {	id: '', status:1,title:'',pagerule:'',category: '', tags: []},
	 pageList: [],
	 motherspageList: [],
	 addpagefiles: [],	 
	 page_toprated: [],
	 page_featured: [],
	 page_topviewed: [],
	 page_category: [],
	 currentpageid: '',
	 editpagedialog: false,
	 
	 //sms
	 dfrom:"",
	 dtomenuid:'',
	 eventmobile:[],
	 smsevents:[],
	// to:"+916379112113", gg
	 from:"", //twillio +15102704301
	// to:'+918508430849', dd
	// to:'+919894435788', //sara
	 // to:'+15303885251', //skype
	//  to:'+19843632722', //nandhini twilio
	 to:'',
	 todata:null,
	 totalconversation:0,
	 eventdetails:{},
	 eventstatus:[],
	
	//Todos
	subtabitemid:'data',
	stripeauthresult:{},
	subid:null,
	itemid:null,
	
	addeventdialog:false,
	templatevalue:"",
	projcalid:"",
	selectedid:"",
	calendsubname:'lists',
	calendsubid:'all',
	todostates:[],
	todostatus:[],
	todos:[],
	repetitivelogsdialog:false,
	repetitivelogsid:'',
	editdialog:false,
	edittype:'',
	edittodo:{},
	todolistfiles:[],
	recenttodos:[],
	todotitle_id:{},
	selectedlist_id:[], //For selecting sublist items
	todos_list:[], //For selecting sublist  - todos
	todoprojects:[],
	listduedate:new Date().toISOString().substr(0, 10),
	todoprojectfiles: [],
	addprojdialog: false,
	addlistdialog: false,
	addlisttaskdialog: false,
	todolistfiles: [],
	listtabactive: '/checklist/lists',
	addtodotask : {title: '', description:'', address: '', type:'tasks',listduedate:''},
	actionlogs: [],
	
	//States Phases
	addstates: {id: '', title: '', description: '', color: '#FFFFFF', icon: '', keywords: '', states: [{name: '' , color: '#FFFFFF'},{name: '' , color: '#FFFFFF'},{name: '' , color: '#FFFFFF'},{name: '' , color: '#FFFFFF'},{name: '' , color: '#FFFFFF'}] },
	//Status settings
	addstatus: {id: '', title: '', description: '', color: '#FFFFFF', icon: '', keywords: '', status: [{name: '' , color: '#FFFFFF'},{name: '' , color: '#FFFFFF'},{name: '' , color: '#FFFFFF'},{name: '' , color: '#FFFFFF'},{name: '' , color: '#FFFFFF'}] },
 
	//Project Share
	sharetodoprojects:{},
	selectedshareduser:[],
	sharedialog: false,	
	
	pass_listtype: '',
	
	//subscriptions
	subscriptionslist:[],
	profilemenutype:'home',
 
	//KS
	ksdashboard: { total: 0, upcoming: 0, today: 0, items: [] },
	 knowledgeserviceInfo:{ 
		displayName: '',
		description: '',
		subscriptiontype: 'fixeddatesubscription',
		keywords: '',
		totalperiod: {	
			type: 'day',
			days: 0,
			weeks: 0,
			months: 0,
		},		  
		alerts: {			  
			contacts: {},
			privatenumber: {},
			notificationtype: [ 'sms', 'email', 'voicecall'],
			notifyon : 900
		},
		paymentoption: 'free',
		servicecost: '0',
	 },
	 ksfiles: [],
	 ksList: [],
	 KSsubscriptionInfo: [],
	 knowledgeserviceQuestionlist: [],
	 //Day activity
	 knowledgeservicedayInfo: {
		displayName: '',
		description: '',
		keywords: '',
		totalperiod: {	
			type: 'day',
			days: 0,
			weeks: 0,
			months: 0,
		},
		alerts: [
			{ id: '', menu: false,tab: 0, alertstype: 'Infoalert',  notificationtype: '', alertcallmessage: '',alertemailmessage: '',alertsmsmessage: '', alerttime: '', alertresponse: '', dependencyrequired: 'no',elapsedtimerequired: 'no', tab2: 0,  anddependency:  { questions: [], totalquestions: 0 },  ordependency:  { questions: [], totalquestions: 0 }, sendresponseon: 'Send to the specified time', elapsed: {days: 0, hours: 0, mins: 0},showresponse: true, startremindertype: 'plist', stopremindertype: 'plist' },
		],		
   
	 },
	 ksdayList: [],
	 addksdialog_Step: 1,
	 
	 //Inbox views
	 inboxdrawer:false,
	 composemail: false,
	 gmailinboxcontab: 0,
	 selectedgmail: {id:''},		 
	 inboxconversationtab: 0,
	 inboxconversationtype: '',
	 allconvmessages:[],
	 indeterminate:false,
	 
	 //Templates
	 saveasmenu:false,
	 draftlist: [],
	 conversationtab:0,
	 contactitems:[],
	 PickedContact: null,
	 templatecat:[],
	 templateselect:{},
	 templatelist:[],
	 templatemessageinput:'',
	 bulksmsphonenumbers:null,
	 
	 
	 //Box Service
	 captureresults:"",
	 qrcoderesults:"",
	 boxserviceitem: { id: '', list: [{name:'', type: '',description: ''}] },
	 boxserviceList: [],
	 boxservicefiles: [],
	 boxservice: { //Services
			id:null,
			ItemNo: null,
			userid: '',
			itemtype: 1,
			slug: '',
			title: '',
			status: true,
			imgurl: "",
			type: '',
			content: '',
			price: '',
			Cost: 'Standard',
			Category: '',
			SubCategory: '',
			Boxname: '',
			Listofitemsinbox: '',
			BoxQuantity: 0,
			BoxLocation: 'California',
			Locationavailability: 'Globally',
			Shipping: 'Delivery',
			ShippingHandlingFee: '',
			CheckoutLength: 'Weeks',
			Dimensions: '',
			LocationAvailabilities: [],
			BoxValue: '',
			Autorenewalallowed: 'No',
			Fileattachments: 'No',
			Packagetracking: 'No',
			Rating: 5,
			Boxstatus: 'Yes',
			Anyonerequest: 'Yes',
			RequestBoxreturn: 'Yes',
			SERVICESECTION: 'Physical',  
			FORMFACTOR: 'Box',  
			GROUP: 'Sharing',
			itempurchasetype: 'Buy',
			uploadedfiles: []  
	  },
	  productlogs:[],
	  productrequests:[],
	  productlogid:''
  },
  mutations: {
	  
    setPageload (state, payload) {
      state.pageloading = payload
    },setUser (state, payload) {
      state.user = payload
      state.userProfileInfo = payload; //Profile Page Edit
    },
    setError (state, payload) {
      state.error = payload
    },
    setLoading (state, payload) {
      state.loading = payload
    },
    setListLoading (state, payload) {
      state.listloading = payload
    },
    setRemainders (state, remainder) {
      state.remainder = remainder
    },
    getsubworkerlist: function(state) {
		state.subworkerlist = [];
		if(state.user  != null && state.user != undefined && state.user  != ''){
			state.workerlistloading = true
			var uid = state.user.uid;
			var requestda = {
				 uid: uid
			};
			var ciphertext = CryptoJS.AES.encrypt(JSON.stringify(requestda), 'DevelopmentLive');
			axios.post(`${window.endpoint}/workspaces/subworkerslist`, {data:ciphertext.toString()}).then(function(res){	
					state.workerlistloading = false
		 			if(res.data.result === undefined || res.data.result === null){  
						state.subworkerlist = [];
					}else {
						state.subworkerlist = res.data.result;
			 		}
			}).catch(err => { 
					state.workerlistloading = false
			});
		}
	},
	getworkerlist: function(state) {
		state.wsworkerlist = [];
		if(state.user  != null && state.user != undefined && state.user  != '' && state.workspacesid  != '' && state.workspacesid  != undefined){
			state.workerlistloading = true
			console.log('state.wsworkerlist',state.workspacesid);
			//var uid = state.user.uid;
			 if(state.user.Type == 'Subaccount'){
				var uid = state.user.primaryuid
			 }else{
				var uid = state.user.uid;
			 }
			var requestda = {
				 uid: uid,
				 workspacesid:state.workspacesid,
			};
			var ciphertext = CryptoJS.AES.encrypt(JSON.stringify(requestda), 'DevelopmentLive');
			axios.post(`${window.endpoint}/workspaces/workerslist`, {data:ciphertext.toString()}).then(function(res){	
					state.workerlistloading = false
		 			if(res.data.result === undefined || res.data.result === null){  
						state.wsworkerlist = [];
					}else {
						state.wsworkerlist = res.data.result;
			 		}
			}).catch(err => { 
					state.workerlistloading = false
			});
		}
	},
	// TaskRouters
	  getworkspacefulldetails: function(state) {
		 if(state.user  != null && state.user != undefined && state.user  != ''){
			//var uid = state.user.uid;
			 if(state.user.Type == 'Subaccount'){
				var uid = state.user.primaryuid
			 }else{
				var uid = state.user.uid;
			 }
			var requestda = {
				 uid: uid
			};
			var ciphertext = CryptoJS.AES.encrypt(JSON.stringify(requestda), 'DevelopmentLive');
			axios.post(`${window.endpoint}/firebase/workspace/list-workspacedetails`, {data:ciphertext.toString()}).then(function(res){	
		 			if(res.data.resultSet === undefined && res.data.resultSet === null){  
						 state.workspaces = [];
					}else {
						 state.workspaces = res.data.resultSet;
						 if(state.workspacesid == ''){
							 state.workspacesid = res.data.selected;
						 }
						 if(res.data.selectedworkspaces != '' && res.data.selectedworkspaces != undefined && res.data.selectedworkspaces != null){
							state.workspacesdata = res.data.selectedworkspaces;
						 }
						 store.commit('getactivities');	
						 store.commit('gettasklist');
						 store.commit('getworkerlist'); //getworkerlist
			 		}
			}).catch(err => { });
		}
	},upselectedworkspace: function(state,payload) {
		  if(state.user  != null && state.user != undefined && state.user  != ''){
			  console.log('state.workspaces',state.workspaces);
			  if(state.workspaces != undefined && state.workspaces.length > 0){

				//var uid = state.user.uid;
				 if(state.user.Type == 'Subaccount'){
					var uid = state.user.primaryuid
				 }else{
					var uid = state.user.uid;
				 }
				var wid = payload.wid;
				var requestda = {uid: uid,wid: wid};  
				for(var i = 0; i < state.workspaces.length; i++){

					if( state.workspaces[i].sid == wid){
						state.workspacesdata = state.workspaces[i];
						store.commit('getactivities');	
						store.commit('gettasklist'); 
						store.commit('getworkerlist'); //getworkerlist
					}

				}
				var ciphertext = CryptoJS.AES.encrypt(JSON.stringify(requestda), 'DevelopmentLive');
				axios.post(`${window.endpoint}/firebase/workspace/updatewid`, {data:ciphertext.toString()}).then(function(res){	
						if(res.data.resultSet === undefined && res.data.resultSet === null){  
							 //state.workspaces = [];
						}else {
							 //state.workspaces = res.data.resultSet;
							 //state.workspacesid = res.data.selected;
							 //state.workspacesdata = res.data.selectedworkspaces;
						}
				}).catch(err => { });
			}
		}
	},upselectedworkspace: function(state,payload) {
		  if(state.user  != null && state.user != undefined && state.user  != ''){
			  console.log('state.workspaces',state.workspaces);
			  if(state.workspaces != undefined && state.workspaces.length > 0){

				//var uid = state.user.uid;
				 if(state.user.Type == 'Subaccount'){
					var uid = state.user.primaryuid
				 }else{
					var uid = state.user.uid;
				 }
				var wid = payload.wid;
				var requestda = {uid: uid,wid: wid};  
				for(var i = 0; i < state.workspaces.length; i++){

					if( state.workspaces[i].sid == wid){
						state.workspacesdata = state.workspaces[i];
						store.commit('getactivities');	
						store.commit('gettasklist'); 
						store.commit('getworkerlist'); //getworkerlist
					}

				}
				var ciphertext = CryptoJS.AES.encrypt(JSON.stringify(requestda), 'DevelopmentLive');
				axios.post(`${window.endpoint}/firebase/workspace/updatewid`, {data:ciphertext.toString()}).then(function(res){	
						if(res.data.resultSet === undefined && res.data.resultSet === null){  
							 //state.workspaces = [];
						}else {
							 //state.workspaces = res.data.resultSet;
							 //state.workspacesid = res.data.selected;
							 //state.workspacesdata = res.data.selectedworkspaces;
						}
				}).catch(err => { });
			}
		}
	},
	getactivities: function(state) {
		state.currentworkspace.activities = [];
		if(state.user  != null && state.user != undefined && state.user  != '' && state.workspacesid  != '' && state.workspacesid  != undefined){
			console.log('state.activities',state.workspacesid);
			//var uid = state.user.uid;
			 if(state.user.Type == 'Subaccount'){
				var uid = state.user.primaryuid
			 }else{
				var uid = state.user.uid;
			 }
			var requestda = {
				 uid: uid,
				 workspacesid:state.workspacesid,
			};
			var ciphertext = CryptoJS.AES.encrypt(JSON.stringify(requestda), 'DevelopmentLive');
			axios.post(`${window.endpoint}/firebase/activities/list`, {data:ciphertext.toString()}).then(function(res){	
		 			if(res.data.resultSet === undefined || res.data.resultSet === null){  
						state.currentworkspace.activities = [];
					}else {
						state.currentworkspace.activities = res.data.resultSet;
			 		}
			}).catch(err => { });
		}
	},
	gettasklist: function(state) {
		state.wstasklist = [];
		if(state.user  != null && state.user != undefined && state.user  != '' && state.workspacesid  != '' && state.workspacesid  != undefined){
			state.tasklistloading = true
			console.log('state.wstasklist',state.workspacesid);
			//var uid = state.user.uid;
			 if(state.user.Type == 'Subaccount'){
				var uid = state.user.primaryuid
			 }else{
				var uid = state.user.uid;
			 }
			var requestda = {
				 uid: uid,
				 workspacesid:state.workspacesid,
			};
			var ciphertext = CryptoJS.AES.encrypt(JSON.stringify(requestda), 'DevelopmentLive');
			axios.post(`${window.endpoint}/workspaces/tasklist`, {data:ciphertext.toString()}).then(function(res){	
					state.tasklistloading = false
		 			if(res.data.result === undefined || res.data.result === null){  
						state.wstasklist = [];
					}else {
						state.wstasklist = res.data.result;
			 		}
			}).catch(err => { 
					state.tasklistloading = false
			});
		}
	},
	//Private Numbers
	getprivatenumbers: function(state){
		  if(state.user  != null && state.user != undefined && state.user  != ''){
			state.pvtloading =  true
			var uid =state.user.uid;
			axios.get(`${window.endpoint}/firebase/twilio/getprivatenumbers/`+uid) 
			 .then((res) => {	
				 state.pvtloading =   false
				 state.AccountPVTnotification = true;
				 //console.log('res.data[0].rows',res.data[0].rows);
				 //console.log('res.data[0].rows.length',res.data[0].rows.length);
				 /*if(res.data[0].rows.length > 0){
					  state.privateNumbers.List = res.data[0].rows[0].PrivateNumberList;
					  state.privateNumbers.ownerAccountSid = res.data[0].rows[0].ownerAccountSid;
					  state.privateNumbers.clientsid = res.data[0].rows[0].sid;
					  state.privateNumbers.authToken = res.data[0].rows[0].authToken;
					  state.privateNumbers.NumberDetails = res.data[0].rows[0].pvtnumbers;
					  state.privateNumbers.selected = res.data[0].rows[0].selected;
					  state.privateNumbers.defaultnumber = res.data[0].rows[0].defaultnumber;
					  state.privateNumbers.status = 1;
				 }		*/	
				 state.privateNumbers.NumberDetails = res.data[0].rows;
				
			}).catch(err => {	console.log(err); state.AccountPVTnotification = true;	state.pvtloading = false; });		
		}		  
	  },
	  //Private Numbers
	 getallprivatenumbers: function(state){
		  if(state.user  != null && state.user != undefined && state.user  != ''){
			state.pvtloading =  true
			var uid ='all';
			axios.get(`${window.endpoint}/firebase/twilio/getprivatenumbers/`+uid) 
			 .then((res) => {	
				 state.pvtloading =   false
				 state.availableNumbers = res.data[0].rows;
				
			}).catch(err => {	console.log(err);  	state.pvtloading = false; });		
		}		  
	  },
	  purchaseprivatenumber: function(state){
		if(state.user  != null && state.user != undefined && state.user  != ''){	
		 var uid =state.user.uid;
			axios.post(`${window.endpoint}/firebase/twilio/purchaseprivatenumber/`, {uid:uid }).then((res) => {		
				 console.log('res.data',res.data);
				 store.commit('getprivatenumbers');	
			}).catch(err => {	console.log(err);	});  
		}
	  },
	  upselectedprivatenumbers: function(state,payload){ //to Update selected number - api calling
		  
		  if(state.user  != null && state.user != undefined && state.user  != ''){
			  var uid =state.user.uid;
			  var phone = payload.phone;
			  var phonesid = payload.phonesid;
				axios.post(`${window.endpoint}/firebase/twilio/updateselected/`, {uid:uid,phone:phone,phonesid:phonesid }).then((res) => {	
					 //var PrivateNumber = {};
					 //console.log('res.data',res.data);
				}).catch(err => {	console.log(err);	});				  
		  }
	  },
	  searchprivatenumber: function(state,payload){
		if(state.user  != null && state.user != undefined && state.user  != ''){	
		 state.phonenumbersearchload = true;
		 var uid =state.user.uid;
		 var region =payload.region; //areaCode or region or search any number
		 var country =payload.country;
			axios.post(`${window.endpoint}/firebase/twilio/searchprivatenumber/`, {uid:uid, region:region, country:country }).then((res) => {	
				state.phonenumbersearchload = false;	
				if(!res.data.error){
					state.phonenumberlist = 	res.data.numberlist;
				}else{
					state.phonenumberlist = 	{};	
				}
				 //store.commit('getprivatenumbers');	
			}).catch(err => {	console.log(err);state.phonenumbersearchload = false;	state.phonenumberlist = 	{};		});  
		}
	  },
	  buyselectedprivatenumber: function(state,payload){
		if(state.user  != null && state.user != undefined && state.user  != ''){	
		 state.phonenumbersearchload = true;
		 var uid =state.user.uid;
		 var number =payload.number;
		 var type =payload.type;
		 state.phonenumbersearchload = false;
		 state.addpvtdialog=false;
			axios.post(`${window.endpoint}/firebase/twilio/buyprivatenumber/`, {uid:uid,number:number,type:type }).then((res) => {
				state.phonenumbersearchload = false;		
				 console.log('res.data',res.data);
				 //store.commit('getprivatenumbers');	
			}).catch(err => {	state.phonenumbersearchload = false;		console.log(err);	});  
		}
	  },
    //Trackingterms TypeDefine tables
	getTTTableslist: function(state,payload){ 
		var uid =state.user.uid;
		if(uid){		 
			 axios.post(`${window.endpoint}/firebase/users/gettableslists`, {uid:uid}) 
			 .then((res) => {	
				// console.log('res',res.data.rows)
				var ItemSet =  res.data.rows;
				state.TTTableslist = ItemSet; 				
			}).catch(err => {	console.log(err);	});		 
		}
	}, 	
	 //TT Platforms Groups
	getplatformlist: function(state,payload){ 
		var uid =state.user.uid;
		if(uid){		 
			 axios.defaults.headers.common['Authorization'] =  'Bearer ' + localStorage.getItem('abittoken');
			 axios.post(`${window.devendpoint}/firebase/users/getappplatform`) 
			 .then((res) => {	
				// console.log('res',res.data.rows)
				var ItemSet =  res.data.rows;
				state.Platformlist = ItemSet; 				
			}).catch(err => {	console.log(err);	});		 
		}
	}, 	
	 //TT - Groups
	getTTGroupslist: function(state,payload){ 
		var uid =state.user.uid;
		if(uid){		 
			axios.defaults.headers.common['Authorization'] =  'Bearer ' + localStorage.getItem('abittoken');
			 axios.post(`${window.devendpoint}/firebase/users/gettrackinggrouplists`, {uid:uid}) 
			 .then((res) => {	
				// console.log('res',res.data.rows)
				var ItemSet =  res.data.rows;
				state.TTGroupslist = ItemSet; 				
			}).catch(err => {	console.log(err);	});		 
		}
	}, 	
	 //Entity - Groups
	getEntViewslist: function(state,payload){ 
		var uid =state.user.uid;
		if(uid){	
			axios.defaults.headers.common['Authorization'] =  'Bearer ' + localStorage.getItem('abittoken');	 
			 axios.post(`${window.devendpoint}/firebase/users/getentitygrouplists`, {uid:uid}) 
			 .then((res) => {	
				// console.log('res',res.data.rows)
				var ItemSet =  res.data.rows;
				state.EntViewslist = ItemSet; 				
			}).catch(err => {	console.log(err);	});		 
		}
	}, 	
	 //Actions
	getActionlist: function(state,payload){ 
		var uid =state.user.uid;
		if(uid){	
			axios.defaults.headers.common['Authorization'] =  'Bearer ' + localStorage.getItem('abittoken');	 
			 axios.post(`${window.devendpoint}/firebase/users/getactionlists`, {uid:uid}) 
			 .then((res) => {	
				// console.log('res',res.data.rows)
				var ItemSet =  res.data.rows;
				state.listactions = ItemSet; 				
			}).catch(err => {	console.log(err);	});		 
		}
	}, 	
	//Contacts & Groups
	getGroupContactlist: function(state,payload){
		var gid =payload.gid;
		var uid =state.user.uid;
		if(uid){		 
			 axios.get(`${window.endpoint}/firebase/contact/getcontact/`+uid) 
			 .then((res) => {	
				var GroupSet =  res.data[0].rows ;
				if(gid !== '' && gid !== undefined){
					state.selectedGroups = gid;
					//state.groupcontacts =  GroupSet.filter(function (grp) { return grp.groupid ===  gid })    
					state.contacts =  GroupSet.filter(function (grp) { return grp.groupid ===  gid })    
					state.listcontacts =  GroupSet.filter(function (grp) { return grp.groupid ===  gid })    
				}else{
					//state.groupcontacts = GroupSet;
					state.contacts = GroupSet;
					state.listcontacts = GroupSet;
				}
				
			}).catch(err => {	console.log(err);	});		 
		}
	},
	/*getContactlist: function(state){	
	  if(state.user  != null && state.user != undefined && state.user  != ''){	 
		 var uid =state.user.uid;
		 if(uid){		 
			 axios.get(`${window.endpoint}/firebase/contact/getcontact/`+uid) 
			 .then((res) => {		
				 state.contacts = res.data[0].rows ;
				 state.listcontacts = res.data[0].rows ;
			}).catch(err => {	console.log(err);	});		 
		 }			
	  }			
	},
	getGrouplist: function(state){		
	  if(state.user  != null && state.user != undefined && state.user  != ''){	 
		 var uid =state.user.uid;
		 if(uid){		 
			 axios.get(`${window.endpoint}/firebase/contact/getgroup/`+uid) 
			 .then((res) => {		
				 state.groups = res.data[0].rows ;	
			}).catch(err => {	console.log(err);	});		 
		 }			
	 }			
	},*/
	getContactlist: function(state,payload){	
	  if(state.user  != null && state.user != undefined && state.user  != ''){	
	  	console.log('payload',payload) 
		 var uid =state.user.uid;
		 var pagecount=payload.pagecount;
		 var pagelength=payload.pagelength;
		 // var pagelength=payload.pagelength;
		 var searchkey=payload.type;
		 console.log('pg length,pg count--',pagelength,pagecount)
		 if(searchkey=='' || searchkey==null || searchkey==undefined || typeof searchkey=='undefined'){
		 	searchkey='';
		 }
		  if(uid){	
		 	store.commit('setPageload', true);
			store.commit('setLoading', true);   
			state.datalength='';
			if(typeof state.user.Type !==undefined){
				 var usertype =state.user.Type;
			}else{
				 var usertype='Master';
			}
			 axios.defaults.headers.common['Authorization'] =  'Bearer ' + localStorage.getItem('abittoken');
			 axios.post(`${window.devendpoint}/firebase/contacts/getcontact/`+uid+'/'+pagecount+'/'+pagelength+'/'+searchkey,{usertype:usertype}) 
			 .then((res) => {
			 	console.log(res.data.rows)
				 state.contacts=res.data.rows;
				 state.listcontacts=res.data.rows;
			  	if(state.listcontacts.length>0){
			  		for(var i=0;i<state.listcontacts.length;i++){
			  			var groupnames=[];
			  			var groupids=state.listcontacts[i].groupids;
			  			for(var j=0;j<groupids.length;j++){
			  				var filterresult = state.groups.filter(function (e) {
								return e.id == groupids[j];
						   	});
						   	if(filterresult[0]!=undefined){
						   		groupnames.push(filterresult[0].name)
						   	}else{
						   		groupnames.push('')
						   	}
			  			}
			  			state.listcontacts[i].groupname=groupnames.toString();
			  		}
			  		state.datalength=res.data.rows[0].full_count;
			  	}
			  	store.commit('setPageload', false);
				store.commit('setLoading', false);   
			}).catch(err => {	console.log(err);		 
				store.commit('setPageload', false);
				store.commit('setLoading', false);   
			});
		 }			
	  }			
	},

	getGrouplist: function(state){		
	  if(state.user  != null && state.user != undefined && state.user  != ''){	 
		 const uid =state.user.uid;const username=state.user.displayName;
		 if(uid){	
		     axios.defaults.headers.common['Authorization'] =  'Bearer ' + localStorage.getItem('abittoken');
		 	 axios.get(`${window.devendpoint}/firebase/contacts/getgroup/`+uid) 
			 .then((res) => {	
				state.groups = res.data.data[0];
				state.contact_roles = res.data.data[1];
  				state.objectTypes = res.data.data[2];
	    	}).catch(err => {console.log(err);});		 
		 }			
	 }		
	},
	inviteContact:function(state,payload){
	  if(state.user  != null && state.user != undefined && state.user  != ''){	 
		var uid =state.user.uid;
		if(uid){		 
			var requestda = {
				 type: 'singlecontact',
				 id: payload.in_id,
				 phone: payload.ph_id,
				 uid: uid
			};
			var ciphertext = CryptoJS.AES.encrypt(JSON.stringify(requestda), 'DevelopmentLive');	
			axios.defaults.headers.common['Authorization'] =  'Bearer ' + localStorage.getItem('abittoken');		
			axios.post(`${window.devendpoint}/firebase/contact/inviteservice/`, {data:ciphertext.toString()}).then(function(response){
				if(response.data.response){
					alert(response.data.response);
					store.commit('getContactlist');
					//store.commit('getActivity');	
				}
				
			}).catch(err => {	console.log(err);	});		 
		}	
	  }	
	},
	inviteGroup:function(state,payload){
		var uid =state.user.uid;
		if(uid){		 
			var requestda = {
				 type: 'singlegroup',
				 id: payload.g_id,
				 uid: uid
			};
			var ciphertext = CryptoJS.AES.encrypt(JSON.stringify(requestda), 'DevelopmentLive');		
			axios.defaults.headers.common['Authorization'] =  'Bearer ' + localStorage.getItem('abittoken');	
			axios.post(`${window.devendpoint}/firebase/contact/inviteservice/`, {data:ciphertext.toString()}).then(function(response){
				if(response.data.response){
					alert(response.data.response);
					//store.commit('getContactlist');
					//store.commit('getGrouplist');
					//store.commit('getActivity');	
				}
				
			}).catch(err => {	console.log(err);	});		 
		}

	},
	getActivity: function(state){
	  if(state.user  != null && state.user != undefined && state.user  != ''){	 
		 var uid =state.user.uid;
		 var listtype =state.activitylogtype;
		 console.log('Activity Type:: '+listtype);
		 if(uid){	
		  axios.defaults.headers.common['Authorization'] =  'Bearer ' + localStorage.getItem('abittoken');
		 	 axios.get(`${window.devendpoint}/firebase/contact/getactivitylogs/${uid}/${listtype}`) 
			 .then((res) => {				 
				 state.activityloghistory = res.data[0].rows ;		
			}).catch(err => {	console.log(err); });
		 }
	  }
	},
	
	//Google Maps
	getgMapInputLocation: function(state){
		var SearchingLoc =state.gMapsearchAddressInput;
		var geocoder = new google.maps.Geocoder();
		geocoder.geocode({'address': SearchingLoc}, (results, status) => {
			if (status === 'OK') {
				state.gMapsearchAddressResult = results;
				state.gMapcoordinates = {
					lat: results[0].geometry.location.lat(),
					lng: results[0].geometry.location.lng(),
				}
			}
			state.gMapmarkers = []; //reset every time only need Single place, else All Marked Place will show here
			state.gMapmarkers.push({ position: state.gMapcoordinates,draggable:true, });
			state.gMapcenter = state.gMapcoordinates;			
		  });			
	  },
	resetgMapInputLocation: function(state){
		state.gMapmarkers= [];
		state.gMapsearchAddressInput = "";
		state.gMapsearchAddressResult= null, //googleMap Full address details
		state.gMapcoordinates={ lat: null, lng: null} ;
		state.gMapcenter={ lat: +45.508, lng: -73.587 };
		state.gMapzoom= 16;
	},
	
	//Portfolio
	getPortfolio: function(state){
	  if(state.user  != null && state.user != undefined && state.user  != ''){	 
		 var uid =state.user.uid;
		 if(uid){	
			 store.commit('setLoading', true)	 
		 	 axios.get(`${window.endpoint}/firebase/users/portfoliolist/${uid}`) 
			 .then((res) => {				 
				 store.commit('setLoading', false)
				 state.portfolioList = res.data.rows ;		
			}).catch(err => {
				store.commit('setLoading', false);	console.log(err); 
			});
		 }
	  }
	},
	
	//Mothers day
	getmotherscelebrate: function(state){
	  if(state.user  != null && state.user != undefined && state.user  != ''){	 
		 var uid =state.user.uid;
		 if(uid){	
			 store.commit('setLoading', true)	 
			 store.commit('setPageload', true)	
		 	 //axios.post(`${window.endpoint}/firebase/users/mothersday`, { useremail: state.user.emailaddress ,uid: uid}) 
		 	 axios.get(`${window.endpoint}/firebase/users/mothersday`) 
			 .then((res) => {				 
				 store.commit('setLoading', false)
				 store.commit('setPageload', false)
				 
				 state.motherspageList = res.data;
				 	
			}).catch(err => {
				store.commit('setLoading', false);  
				store.commit('setPageload', false);	console.log(err); 
			});
		 }
	  }
	},
	//Pages
	getpages: function(state){
	  if(state.user  != null && state.user != undefined && state.user  != ''){	 
		 var uid =state.user.uid;
		 if(uid){	
			 store.commit('setLoading', true)	 
			 store.commit('setPageload', true)	
		 	 axios.post(`${window.endpoint}/firebase/users/pagelist`, { useremail: state.user.emailaddress ,uid: uid}) 
			 .then((res) => {				 
				 store.commit('setLoading', false)
				 store.commit('setPageload', false)
				 
				 state.pageList = res.data.rows ;		
				 state.page_toprated = res.data.toprated ;		
				 state.page_featured = res.data.featured ;		
				 state.page_topviewed = res.data.topviewed ;		
				 state.page_category = res.data.category ;	
				 	
			}).catch(err => {
				store.commit('setLoading', false);  
				store.commit('setPageload', false);	console.log(err); 
			});
		 }
	  }
	},
	//Box Service
	getboxservice: function(state){
	  if(state.user  != null && state.user != undefined && state.user  != ''){	 
		 var uid =state.user.uid;
		 if(uid){	
			 store.commit('setLoading', true)	 
			 store.commit('setPageload', true)
			 state.boxserviceList = [];	
		 	 axios.post(`${window.endpoint}/firebase/users/boxserviceslist`, {uid: uid}) 
			 .then((res) => {				 
				 store.commit('setLoading', false)
				 store.commit('setPageload', false)
				 
				 state.boxserviceList = res.data.rows ;			
				 	
			}).catch(err => {
				store.commit('setLoading', false);  
				store.commit('setPageload', false);	console.log(err); 
			});
		 }
	  }
	},
	//Knowledge Service
	getks: function(state){
	  if(state.user  != null && state.user != undefined && state.user  != ''){	 
		 var uid =state.user.uid;
		 if(uid){	
			 store.commit('setLoading', true)	 
			 store.commit('setPageload', true)
			 state.ksList = [];	
		 	 axios.post(`${window.endpoint}/firebase/users/knowledgeserviceslist`, {uid: uid}) 
			 .then((res) => {				 
				 store.commit('setLoading', false)
				 store.commit('setPageload', false)
				 
				 state.ksList = res.data.rows ;			
				 	
			}).catch(err => {
				store.commit('setLoading', false);  
				store.commit('setPageload', false);	console.log(err); 
			});
		 }
	  }
	},
	getdayks: function(state, payload){
	  if(state.user  != null && state.user != undefined && state.user  != ''){	 
		 var uid =state.user.uid;
		 if(uid){	
			 store.commit('setLoading', true)	 
			 store.commit('setPageload', true)	
			 state.ksdayList = [];
		 	 axios.post(`${window.endpoint}/firebase/users/dayknowledgeserviceslist`, {uid: uid,ksid :payload.id}) 
			 .then((res) => {				 
				 store.commit('setLoading', false)
				 store.commit('setPageload', false)
				 
				 state.ksdayList = res.data.rows ;	
				 state.knowledgeserviceQuestionlist = res.data.filteredQues;		
				 	
			}).catch(err => {
				store.commit('setLoading', false);  
				store.commit('setPageload', false);	console.log(err); 
			});
		 }
	  }
	},
	//getemailaccount list - table by user
	getemailaccount: function(state,payload){
	  if(state.user  != null && state.user != undefined && state.user  != ''){	 
		 var uid =state.user.uid;
		 if(uid){	
			 store.commit('setLoading', true)	 
			 store.commit('setPageload', true)	
			 axios.defaults.headers.common['Authorization'] =  'Bearer ' + localStorage.getItem('abittoken'); 
		 	 axios.get(`${window.devendpoint}/voip/firebase/getemailaccount/`+uid+'/google', { uid: uid }) 
			 .then((res) => {				 
				 store.commit('setLoading', false)
				 store.commit('setPageload', false)
				 if(res.data.rows.length > 0){
					state.EmailAccountList = res.data.rows ;	
				}else{	 	
					state.EmailAccountList = [] ;	
				}	 	
			}).catch(err => {
				store.commit('setLoading', false);  
				store.commit('setPageload', false);	console.log(err); 
			});
		 }
	  }
    },
	//gettrackingterms
	gettrackingterms: function(state){
	  if(state.user  != null && state.user != undefined && state.user  != ''){	 
		 var uid =state.user.uid;
		 if(uid){	
			 store.commit('setLoading', true)	 
			 store.commit('setPageload', true)	
			 axios.defaults.headers.common['Authorization'] =  'Bearer ' + localStorage.getItem('abittoken'); 
		 	 axios.post(`${window.devendpoint}/firebase/users/gettrackingterms`, { uid: uid}) 
			 .then((res) => {				 
				 store.commit('setLoading', false)
				 store.commit('setPageload', false)
				 state.addtrackingtermsParents = res.data.rows ;		
				 state.listtrackingtermsfilters = res.data.rows ;		
				 state.listtrackingterms = res.data.rows ;		
			}).catch(err => {
				store.commit('setLoading', false);  
				store.commit('setPageload', false);	console.log(err); 
			});
		 }
	  }
    },
	//getentitylist - table by user
	getusertableentitylist: function(state,payload){
	  if(state.user  != null && state.user != undefined && state.user  != ''){	 
		 var uid =state.user.uid;
		 if(uid){	
			 store.commit('setLoading', true)	 
			 store.commit('setPageload', true)	
			 axios.defaults.headers.common['Authorization'] =  'Bearer ' + localStorage.getItem('abittoken'); 
		 	 axios.post(`${window.devendpoint}/thirdparty/googlehome/getusertableentity`, { uid: uid, authkeyid: payload.authkeyid,project_id: payload.project_id }) 
			 .then((res) => {				 
				 store.commit('setLoading', false)
				 store.commit('setPageload', false)
				 state.EntityList = res.data.rows ;		
				 state.EntityListfilters = res.data.rows ;		
			}).catch(err => {
				store.commit('setLoading', false);  
				store.commit('setPageload', false);	console.log(err); 
			});
		 }
	  }
    },
	//getentitylist
	getentitylist: function(state){
	  if(state.user  != null && state.user != undefined && state.user  != ''){	 
		 var uid =state.user.uid;
		 if(uid){	
			 store.commit('setLoading', true)	 
			 store.commit('setPageload', true)	 
			 axios.defaults.headers.common['Authorization'] =  'Bearer ' + localStorage.getItem('abittoken');
		 	 axios.post(`${window.devendpoint}/firebase/users/getentities`, { uid: uid}) 
			 .then((res) => {				 
				 store.commit('setLoading', false)
				 store.commit('setPageload', false)
				 state.EntityList = res.data.rows ;		
				 state.EntityListfilters = res.data.rows ;		
			}).catch(err => {
				store.commit('setLoading', false);  
				store.commit('setPageload', false);	console.log(err); 
			});
		 }
	  }
    },
	//getauthkeylist
	getauthkeylist: function(state){
	  if(state.user  != null && state.user != undefined && state.user  != ''){	 
		 var uid =state.user.uid;
		 if(uid){	
			 store.commit('setLoading', true)	 
			 store.commit('setPageload', true)	 
			 axios.defaults.headers.common['Authorization'] =  'Bearer ' + localStorage.getItem('abittoken');
		 	 axios.post(`${window.devendpoint}/firebase/users/authjsonkeylist`, { uid: uid}) 
			 .then((res) => {				 
				 store.commit('setLoading', false)
				 store.commit('setPageload', false)
				 state.AuthKeyList = res.data.rows ;		
			}).catch(err => {
				store.commit('setLoading', false);  
				store.commit('setPageload', false);	console.log(err); 
			});
		 }
	  }
    },
	//codebook
	getcodebook: function(state){
	  if(state.user  != null && state.user != undefined && state.user  != ''){	 
		 var uid =state.user.uid;
		 if(uid){	
			 store.commit('setLoading', true)	 
			 store.commit('setPageload', true)	
			 //axios.get(`${window.endpoint}/firebase/users/bloglist/${uid}`)  
			 axios.defaults.headers.common['Authorization'] =  'Bearer ' + localStorage.getItem('abittoken');
		 	 axios.post(`${window.devendpoint}/firebase/users/getcodebookfiles`, { useremail: state.user.emailaddress ,uid: uid}) 
			 .then((res) => {				 
				 store.commit('setLoading', false)
				 store.commit('setPageload', false)
				 state.codebookList = res.data.rows ;		
			}).catch(err => {
				store.commit('setLoading', false);  
				store.commit('setPageload', false);	console.log(err); 
			});
		 }
	  }
    },
	//getjupyterfiles
	getjupyterfiles: function(state){
	  if(state.user  != null && state.user != undefined && state.user  != ''){	 
		 var uid =state.user.uid;
		 if(uid){	
			 store.commit('setLoading', true)	 
			 store.commit('setPageload', true)	
			 axios.defaults.headers.common['Authorization'] =  'Bearer ' + localStorage.getItem('abittoken');
		 	 axios.post(`${window.devendpoint}/firebase/users/getjupyterfiles`, { useremail: state.user.emailaddress ,uid: uid}) 
			 .then((res) => {				 
				 store.commit('setLoading', false)
				 store.commit('setPageload', false)
				 state.jupyterList = res.data.rows ;		
			}).catch(err => {
				store.commit('setLoading', false);  
				store.commit('setPageload', false);	console.log(err); 
			});
		 }
	  }
    },  
	//Blogs & Comments
	getblogs: function(state){
	  if(state.user  != null && state.user != undefined && state.user  != ''){	 
		 var uid =state.user.uid;
		 if(uid){	
			 store.commit('setLoading', true)	 
			 store.commit('setPageload', true)	
			 //axios.get(`${window.endpoint}/firebase/users/bloglist/${uid}`)  
			 //console.log('state.user',state.user)
			 if(state.user.Type=='Subaccount'){
				var UserId = state.user.primaryuid
			 }else{
				var UserId = state.user.uid
			 }			 
			 axios.defaults.headers.common['Authorization'] =  'Bearer ' + localStorage.getItem('abittoken');
		 	 axios.post(`${window.devendpoint}/firebase/users/bloglist`, { useremail: state.user.emailaddress ,uid: UserId}) 
			 .then((res) => {				 
				 store.commit('setLoading', false)
				 store.commit('setPageload', false)
				 state.blogList = res.data.rows ;		
			}).catch(err => {
				store.commit('setLoading', false);  
				store.commit('setPageload', false);	console.log(err); 
			});
		 }
	  }
	},
	getpagesblogs: function(state,payload){
	  if(state.user  != null && state.user != undefined && state.user  != ''){	 
		 var uid =state.user.uid;
		 if(uid){	
			 store.commit('setLoading', true)	 
			 store.commit('setPageload', true)	
			 //axios.get(`${window.endpoint}/firebase/users/bloglist/${uid}`)  
			 axios.defaults.headers.common['Authorization'] =  'Bearer ' + localStorage.getItem('abittoken');
		 	 axios.post(`${window.devendpoint}/firebase/users/bloglist`, { pageid: payload.pageid, useremail: state.user.emailaddress ,uid: uid}) 
			 .then((res) => {				 
				 store.commit('setLoading', false)
				 store.commit('setPageload', false)
				 state.blogList = res.data.rows ;		
			}).catch(err => {
				store.commit('setLoading', false);  
				store.commit('setPageload', false);	console.log(err); 
			});
		 }
	  }
	},
	getcomments: function(state,payload){
	  if(state.user  != null && state.user != undefined && state.user  != ''){	 
		var uid =state.user.uid;
		if(uid){
			store.commit('setPageload', true)	
			console.log('payload',payload.blogid)
			if(payload.blogid == undefined || payload.blogid == '' || payload.blogid == null){
				state.commentList = [];
				store.commit('setPageload', false)
			}else{				
				axios.defaults.headers.common['Authorization'] =  'Bearer ' + localStorage.getItem('abittoken');	 
				axios.get(`${window.devendpoint}/firebase/users/commentslist/${payload.blogid}`).then((res) => {				 
					store.commit('setPageload', false)
					state.commentList = res.data.rows ;		
				}).catch(err => {
					store.commit('setPageload', false);	console.log(err); 
				});
			}

		}
		 
	  }
	},
	getblogcategory: function(state,payload){
	  if(state.user  != null && state.user != undefined && state.user  != ''){	 
		var uid =state.user.uid;
		if(uid){
			store.commit('setPageload', true)
			// /${uid}
			axios.defaults.headers.common['Authorization'] =  'Bearer ' + localStorage.getItem('abittoken');
			axios.get(`${window.devendpoint}/firebase/users/categorylist`).then(function(res){
				store.commit('setPageload', false)
				if(res.data.error === false){			
					state.CategoryList = res.data.rows ;	
				}		
				
			}).catch(err => {				
				store.commit('setPageload', false);	console.log(err); 
			});
		}
	  }
	},
	getblogsubcategory: function(state,payload){
	  if(state.user  != null && state.user != undefined && state.user  != ''){	 
		var uid =state.user.uid;
		if(uid){
			store.commit('setPageload', true)
			// /${uid}
			axios.defaults.headers.common['Authorization'] =  'Bearer ' + localStorage.getItem('abittoken');
			axios.get(`${window.devendpoint}/firebase/users/subcategorylist`).then(function(res){
				store.commit('setPageload', false)
				if(res.data.error === false){			
					state.SubCategoryList = res.data.rows ;	
				}		
				
			}).catch(err => {				
				store.commit('setPageload', false);	console.log(err); 
			});
		}
	  }
	},
	//ME MOM POP Category
	getmemomcategory: function(state,payload){
	  if(state.user  != null && state.user != undefined && state.user  != ''){	 
		var uid =state.user.uid;
		if(uid){
			store.commit('setPageload', true)
			// /${uid}
			axios.get(`${window.endpoint}/firebase/users/memomcategorylist`).then(function(res){
				store.commit('setPageload', false)
				if(res.data.error === false){			
					state.MEMOMCategoryList = res.data.rows ;	
				}		
				
			}).catch(err => {				
				store.commit('setPageload', false);	console.log(err); 
			});
		}
	  }
	},
	getmemomsubcategory: function(state,payload){
	  if(state.user  != null && state.user != undefined && state.user  != ''){	 
		var uid =state.user.uid;
		if(uid){
			store.commit('setPageload', true)
			// /${uid}
			axios.get(`${window.endpoint}/firebase/users/memomsubcategorylist`).then(function(res){
				store.commit('setPageload', false)
				if(res.data.error === false){			
					state.MEMOMSubCategoryList = res.data.rows ;	
				}		
				
			}).catch(err => {				
				store.commit('setPageload', false);	console.log(err); 
			});
		}
	  }
	},
	/* Stories */
	getstories: function(state){
	  if(state.user  != null && state.user != undefined && state.user  != ''){	 
		 var uid =state.user.uid;
		 if(uid){	
			 store.commit('setLoading', true)	 
		 	 axios.get(`${window.endpoint}/firebase/users/coverpagelist/${uid}`) 
			 .then((res) => {				
				 store.commit('setPageload', false); 
				 store.commit('setLoading', false)
				 state.StoriesList = res.data.rows ;		
				 //console.log('res.data.rows.background_image',res.data.rows.background_image)
				 //state.coverfiles = res.data.rows.background_image ;		
			}).catch(err => {
				store.commit('setPageload', false);
				store.commit('setLoading', false);	console.log(err); 
			});
		 }
	  }
	},
	
	getdevicelist: function(state,payload){ //2020 device cal
	  if(state.user  != null && state.user != undefined && state.user  != ''){	 
		var uid =state.user.uid;
		if(uid){
			store.commit('setPageload', true)
			 axios.post(`${window.endpoint}/firebase/twilio/list-connect-details/${uid}`, { uid: uid, todotitle_id: 'all' }).then(dataset => {
				store.commit('setPageload', false)
				if (typeof dataset.data.rows[0] !== "undefined") {
				  state.deviceres = dataset.data.googlehome;
				  state.alexadevices = dataset.data.alexa;
				  
				  
				  if(state.seldeviceid=="" && typeof dataset.data.googlehome[0] !== "undefined"){
					 state.seldeviceid=dataset.data.rows[0].email;
				  }
				  
				  if(state.alexadeviceid=="" && typeof dataset.data.alexa[0] !== "undefined"){
					 state.alexadeviceid=dataset.data.alexa[0].fetchid; 
				  }

				 }else{
				  state.deviceres = [];
				  state.alexadevices = [];
				 }		
				
			}).catch(err => {				
				store.commit('setPageload', false);	console.log(err); 
			});
		}
	  }
	},
	
	//Todo
	setTodolistid:function(state,tid){
      state.todotitle_id = tid;
    },
	setTodoBacklog:function(state,todos){
		//var uid =state.user.uid;
		var tid = 'all';
		   
		var stype="backlog"; 
		var sharelist="backlog"; 
		
		var uid =todos.email;
		   
		var baseurl=`${window.endpoint}/todo/gettodoslist/`+uid+`/`+tid+`/`+stype+`/`+sharelist;  //console.log('baseurl:',baseurl);
		if(tid && uid){
			axios.get(baseurl).then((res) => {	
			     if(res.data.rows){
					//state.todos = res.data.rows;	
				 }else{
					//state.todos = []; 
				 }
			}).catch(err => {	console.log(err);	});
		}
		 
	},
	setTodolistRecentlog:function(state,todos){
		var uid =state.user.uid;
		   
		var baseurl=`${window.endpoint}/todo/getrecenttodoslist/`+uid;
		if(uid){
			axios.get(baseurl).then((res) => {	
			     if(res.data.rows){
					state.recenttodos = res.data.rows;	
				 }else{
					state.recenttodos = []; 
				 }
			}).catch(err => {	console.log(err);	});
		}
		 
	},
	editTodos:function(state,todos){
		  var uid =state.user.uid;	
		  store.commit('setPageload', true); 
		  store.commit('setLoading', true);	  
		  //if(todos.id){		  
			  var stype =state.todotitle_id.type;
			  var tid =state.todotitle_id.id;			  
			  if(state.todotitle_id.sharelist){  
				  var sharelist=state.todotitle_id.sharelist;  
			  }else{
				var sharelist="none";  
			  }	   
			 var baseurl=`${window.endpoint}/todo/gettodoslist/`+uid+`/`+tid+`/`+stype+`/`+sharelist;
		
		 if(tid && uid){
		 	 axios.get(baseurl).then((res) => {	
	  								
			     if(res.data.rows[0]){
					store.commit('setTodoProjects',{listtype:'id', id: res.data.rows[0].todotitle_id });
					state.edittodo = res.data.rows[0];	//Old Method
					state.todolistfiles = res.data.rows[0].uploadedfiles
				 }else{
					state.edittodo = []; 
					state.todolistfiles = []; 
				 }
				store.commit('setPageload', false); 
				store.commit('setLoading', false);
			}).catch(err => {	console.log(err);	});
		 }
    },
    setConfigStates:function(state,todos){
		  var uid =state.user.uid;	
		  var baseurl=`${window.endpoint}/todo/stateslist/`+uid;			
		 if(uid){
		 	 axios.post(baseurl).then((res) => { 				 	
			     if(res.data.rows){
					state.todostates = res.data.rows;	
				 }else{
					state.todostates = []; 
				 }
			}).catch(err => {	console.log(err);	});
		 }
    },
	setConfigStatus:function(state,todos){
		  var uid =state.user.uid;	
		  var baseurl=`${window.endpoint}/todo/statuslist/`+uid;			
		 if(uid){
		 	 axios.post(baseurl).then((res) => { 				 	
			     if(res.data.rows){
					state.todostatus = res.data.rows;	
				 }else{
					state.todostatus = []; 
				 }
			}).catch(err => {	console.log(err);	});
		 }
    },
	setTodolists:function(state,todolists){
		var uid =state.user.uid;
		state.todos_list = todolists.subitems;
	},
	setTodos:function(state,todoid){
		//store.commit('setPageload', true)
		var uid =state.user.uid;	
		if(typeof state.user.Type !==undefined){
			 var usertype =state.user.Type;
		}else{
			 var usertype='Master';
		}
		//console.log('#todotitle_id:',state.todotitle_id);
		
			   var filterlogo = state.todoprojects.filter(function (e) {
					return (e.projectid=="PM-LOGO") 
				}); //console.log('filterlogo:',filterlogo);
				if(typeof filterlogo[0]=="undefined" && usertype=='Master'){
					//console.log('filterlogo:not-added');
					//setTimeout(() => { 		 location.reload(); 	},1000); 2020ROBO
				}else{
					//console.log('filterlogo:added');	
				}
		
		
		  //if(todos.id){		  
			  var stype =state.todotitle_id.type;		  
			  /*if(state.todotitle_id.type=='owner'){
				var tid =state.todotitle_id.id;
			  }else{
					var tid =state.todotitle_id.owner_id;  
			  }*/ //migration
			  var tid =state.todotitle_id.id;
			  
			  if(state.todotitle_id.sharelist){  
				  var sharelist=state.todotitle_id.sharelist;  
			  }else{
				var sharelist="none";  
			  }	 
			  
			  if((tid == undefined || tid == null || tid == "" ) && (todoid !== undefined || todoid !== null || todoid !== "" )){
				  var tid = todoid;
			  }
			  if((stype == undefined || stype == null || stype == "" ) ){
				  var stype = 'owner';
			  }
			  
			  //share
			  if(typeof state.todoprojects.sharetype !==undefined){
				  var stype=state.todotitle_id.sharetype;  
			  }else{
				var stype="none";  
			  }	
			  
			  //assigngrouplist
			  if(typeof state.todoprojects.assigngrouplist !==undefined){
				  var sharetype=state.todotitle_id.assigngrouplist;  
			  }else{
				 var sharetype="none";  
			  }	
			  
			  if((sharetype == undefined || sharetype == null || sharetype == "" ) ){
				  var sharetype="none";  
			  }
			   
			    
			 var baseurl=`${window.devendpoint}/todov1/gettodoslist/`+uid+`/`+tid+`/`+stype+`/`+sharetype;
			 // console.log("baseurl:"+baseurl)
			 
									   
		/* }else{
			 var tid =10000; var stype='test'; var sharelist="none";  
			var baseurl=`${window.endpoint}/admin/firebase/gettodoslist/`+uid+`/`+tid+`/`+stype+`/`+sharelist+`?listtype=All`;	
		 }*/   
	   
		 if(tid && uid){
		 	 axios.defaults.headers.common['Authorization'] =  'Bearer ' + localStorage.getItem('abittoken');
			 axios.get(baseurl).then((res) => {	
	  
				 state.listtabactive = '/checklist/lists';									
			     if(res.data.rows){
					//state.todos = res.data.rows;	//Old Method
					//New Sorting with subitems
					var listitems = res.data.rows;
					 var todoslist= listitems.filter(function (to) { return to.parent_id === '' });
					 var todosublist= listitems.filter(function (to) { return to.parent_id !== '' });
					 todoslist = todoslist.slice(0).sort((a, b) => (a.created  >  b.created  ? 1 : -1 ));
					 todosublist = todosublist.slice(0).sort((a, b) => (a.created  >  b.created  ? 1 : -1 ));
					 todosublist.filter(function (tosub,subindex) { 
						todoslist.filter(function (topar) { 
							if(tosub.parent_id === topar.id){
								var index = todoslist.indexOf(topar)
								todoslist = todoslist.reduce(function(s, a, i) {
								 i == index ? s.push(a, tosub) : s.push(a);
								 return s;
								 }, []);
							}
						});
					  });
					 	if(usertype=='Master'){
					  		state.todos = todoslist;
						}else{
							//state.todos = res.data.rows;
							state.todos = todoslist;
						}
				 }else{
					state.todos = []; 
				 }
				//store.commit('setPageload', false); 
				//store.commit('setLoading', false)
			}).catch(err => {	console.log(err);	});
		 }
	},
	
	setTodoProjects:function(state,payload){
		 
		store.commit('setPageload', true); store.commit('setLoading', true)
		var listtype = 'list';
		if(typeof state.user.Type !==undefined){
			 var usertype =state.user.Type;
		}else{
			 var usertype='Master';
		}
		
		if(payload.id=='all' && state.todoprojects.length>0){
			payload.id=state.todoprojects[0].id;
		}
		
	    var uid =state.user.uid;
		 if(uid && (typeof payload.id !== undefined || payload.id !== null || payload.id !== "" ) && payload.id!='all'){
			 store.commit('setPageload', true);
			 var listtype='all'; var id=payload.id;
			 var purl=`${window.devendpoint}/todov1/gettodos/`+uid+`/`+listtype+`/`+id+`/`+usertype;
			  //console.log("baseurl-1:"+purl)
			
			axios.defaults.headers.common['Authorization'] =  'Bearer ' + localStorage.getItem('abittoken');
		 	axios.get(purl).then((res) => {		
				if(res.data.rows.length>0){  
					  //console.log('proj-id:',id);
					   var curtime = moment.utc().format('YYYY-MM-DD HH:mm:ss');
					   //state.pjroom = id;	
					   state.pjroom='Project'+id;
					   state.pjmessages=[{"name": "admin","text": "Connected to #, "+id,"time": curtime,"color":'green',"room":id}]; 
					   state.pjusers=[];
					  
					  state.todotitle_id = res.data.rows[0];
					  store.commit('setTodos',res.data.rows[0].id);
					  store.commit('setPageload', false);  
				}else{
					state.todotitle_id = {};
					state.todos = [];
					store.commit('setPageload', false); 
			    }
			}).catch(err => {	console.log(err);	store.commit('setPageload', false);  });
		 }else{
			state.todotitle_id = {};
			state.todos = [];
			store.commit('setPageload', false); 
		 }
    },
    //Calling Dynamic contact & Project menu here
    setMenuList:function(state,payload){  
		store.commit('setPageload', false); store.commit('setLoading', false); 
		//console.log('***',state.user);
		if(typeof state.user.Type !==undefined){
			 var usertype =state.user.Type;
		}else{
			 var usertype='Master';
		}
		state.todoprojects = []; 
		state.contactmenu = []; 
		state.cmsmenu = []; 
		state.dbmenu = []; 
	    var uid =state.user.uid;
		 if(uid){ 
			 var purl=`${window.devendpoint}/todov1/getleftmenu/`+uid+`/all/all/`+usertype;
			 //console.log("baseurl-menu-1:"+purl )
			
			axios.defaults.headers.common['Authorization'] =  'Bearer ' + localStorage.getItem('abittoken');
		 	axios.get(purl,{ useremail: state.user.emailaddress }).then((res) => {	
				 //console.log('ROBOT',res.data.menu);
				state.projectmenu=res.data.projectmenu
				state.todoprojects=res.data.todoprojects
				state.contactmenu=res.data.contactmenu 
				state.cmsmenu=res.data.cmsmenu 
				state.dbmenu=res.data.dbmenu 
			}).catch(err => {					
				console.log(err);	
				/*store.commit('setPageload', false); */ });
		 } 
    },
    setTodoProjectData:function(state,payload){  
		store.commit('setPageload', false); store.commit('setLoading', false);
	    var listtype = 'list'; var id = 'all';
		/*state.todoprojects = []; state.todotitle_id = []; state.todos = [];*/
		console.log('***',state.user);
		if(typeof state.user.Type !==undefined){
			 var usertype =state.user.Type;
		}else{
			 var usertype='Master';
		}
		
	    var uid =state.user.uid;
		 if(uid){
			//store.commit('setPageload', true);
			 var listtype='all';
			 var purl=`${window.devendpoint}/todov1/gettodosmenu/`+uid+`/`+listtype+`/`+id+`/`+usertype;
			 //console.log("baseurl-menu-1:"+purl )
			
			axios.defaults.headers.common['Authorization'] =  'Bearer ' + localStorage.getItem('abittoken');
		 	axios.get(purl).then((res) => {	
				 //console.log('ROBOT',res.data.menu);
				//state.projectmenu=res.data.menu
				if(res.data.rows.length>0){   
					state.todoprojects = res.data.rows;
			   }else{
					state.todoprojects = [];	
				}
			}).catch(err => {	state.todoprojects = []; console.log(err);	/*store.commit('setPageload', false); */ });
		 }else{
				state.todoprojects = [];	
				//state.projectmenu=[];
		 }
    },
	setProjectLoglistings:function(state,todos){
		 store.commit('setPageload', true);		 
		 var uid =state.user.uid;	
		 //var searchkey = 'repetitivelogs';
		 var searchkey = 'Project';
		 var currentPage = '1';
		 var limit = '100';
		 var Order = 'new';
		 if(uid){
			 axios.get(`${window.endpoint}/securereminder/getuserlogs/${uid}/${searchkey}/${currentPage}/${limit}/${Order}`, {uid:uid }).then(dataset => {
					var Q2=dataset.data;	
					if(Q2.total != 0){
						var array = Q2.rows;
						 console.log('dd',array);						
						//state.actionlogs =[];
						state.actionlogs = array.sort(function(a, b) {
							var dateA = new Date(a.createdate).getTime();
							var dateB = new Date(b.createdate).getTime();
							//return dateA > dateB ? 1 : -1;   //ascending
							return dateA > dateB ? -1 : 1;   //descending
						});
						store.commit('setPageload', false)
					}else{
						state.actionlogs = [];
						store.commit('setPageload', false)
					}						 
			 }).catch(err => { 
				console.log('console err list  ', err) 
			 }) 
	    }
    }, 
  },
  actions: {
	
	/*DIS*/
	fileContent({ commit, dispatch, state }, payload) {
			commit('setPageload', true)
			commit('setLoading', true)
			const postData = {
				"uid": state.user.uid,
				"file_id": payload.fileId,
				"directory_id": payload.dirId
			}
				axios.post(`${window.apiendpoint}/developer/efileContent`, postData, { headers: { 'Authorization': state.distoken } }).then(response => {
          state.listFileContent = response['data'].rows[0].file_content

				commit('setLoading', false)
				commit('setPageload', false)
				//setTimeout(function () { dispatch('listSongs', {uid: state.user.uid ,collectionid: state.currentcollections.id })  }, 2000)
			}).catch(err => { commit('setLoading', false); commit('setPageload', false); console.log('console err list  ', err) })
	 },
 
	/*Jwt Get Token*/ 
	gettoken ({ commit, dispatch, state }, payload){
		return new Promise((resolve, reject) => {
			
				var token = null;
				fb.auth.onAuthStateChanged((firebaseUser) => {		
					if(firebaseUser){		
						axios.post(`${window.endpoint}/reminder/notifications/token`,{uid:payload.uid,user:{displayName:payload.displayName,uid:payload.uid,emailaddress:payload.emailaddress,Type:payload.Type}}).then(dataset => {
								if(dataset.data.token){
									token = dataset.data.token;
									localStorage.setItem("abittoken", dataset.data.token );
									resolve(token); 
								}else{
									localStorage.setItem("token", null );	
									resolve(token); 				
								}	
						}).catch(err => {
							localStorage.setItem("token", null );	
							resolve(token); 
						})
					}
				})
				
		})//Promise	
	},
	/*User Signup/Signin Starts*/
    updateUserPhone ({commit, dispatch}, payload) {
		commit('setLoading', true)
		if( payload.phonenumber != undefined && payload.phonenumber != ''){
			var RespData = { 'phonenumber': payload.phonenumber };
			fb.db.collection('abitusers').doc(payload.uid).set(RespData,{merge:true}).then(Resp => {
				
				axios.defaults.headers.common['Authorization'] =  'Bearer ' + localStorage.getItem('abittoken');
				axios.post(`${window.devendpoint}/reminder/notifications/update-reminder-phone`, payload ).then(dataset => {
					console.log('updateUserPhone update-reminder-phone Then');
				}).catch(err => {  
					console.log('updateUserPhone update-reminder-phone catch');
				})
				commit('setLoading', false)
				commit('setError', null)
			}).catch(err => {
				commit('setLoading', false)
				commit('setError', 'Error on Updates, Please Try Again')
			})
		}
	},
    userSignUp ({commit, dispatch}, payload) {
      commit('setLoading', true)
      commit('setPageload', true)
      fb.auth.createUserWithEmailAndPassword(payload.email, payload.password)
      .then(firebaseUser => {
		  
		  console.log('payload',payload)
        	//commit('setUser', {email: firebaseUser.user.email,uid:firebaseUser.user.uid })
        	// commit('setLoading', false)
        	//router.push('/home')
        	var cuser = fb.auth.currentUser;
			if(cuser){
				cuser.updateProfile({ displayName: payload.firstname, phoneNumber: payload.phonenumber }).then(function() {  }).catch(function(error) { });
			}
			// create user obj
			var plans = payload.plan;
			if( plans == undefined ){
				plans = {};
			}
			var plan = payload.plan.name;
			if( plan == undefined ){
				plan = 'Demo';
			}
			var planid = payload.plan.id;
			if( planid == undefined ){
				planid = 1;
			}
			
			var sid ='';
			if(typeof payload.sid!=='undefined'){
				if(payload.sid!=''){
					var sid =payload.sid;
				}
			}
			
			
			var RespData = {
					'id': firebaseUser.user.uid,
					'firstname': payload.firstname,
					'displayName': payload.firstname,
					'lastname': '',
					'emailaddress': firebaseUser.user.email,
					'email': firebaseUser.user.email,
					'phonenumber': payload.phonenumber,
					'phonelists': payload.phonelists,
					'uid': firebaseUser.user.uid,
					'Type': 'Master',
					'plans': plans,
					'plan': plan,
					'plan_id': planid,
					'sid':sid
			};
			fb.db.collection('abitusers').doc(firebaseUser.user.uid).set(RespData).then(Resp => {
				
				axios.post(`${window.endpoint}/firebase/users/addusers`,{json:JSON.stringify(RespData)}).then(dataset => {
						console.log('abitusers Collection Success',dataset)	
				}).catch(err => {
						console.log('abitusers Collection Error',err)	
				})
				dispatch('gettoken',RespData).then(token => {				
					if(token){						
						 commit('setUser', RespData )
						 localStorage.setItem("userdetails", JSON.stringify( RespData ))
						 //commit('setUser', {emailaddress: firebaseUser.user.email,email: firebaseUser.user.email,uid:firebaseUser.user.uid,id:firebaseUser.user.uid,phonenumber:payload.phonenumber,firstname:payload.firstname,displayName:payload.firstname,'Type': 'Master' })
						 //localStorage.setItem("userdetails", JSON.stringify({emailaddress: firebaseUser.user.email,email: firebaseUser.user.email,uid:firebaseUser.user.uid,phonenumber:payload.phonenumber,firstname:payload.firstname,displayName:payload.firstname,'Type': 'Master',id:firebaseUser.user.uid }));
						
						 commit('setLoading', false)
						 commit('setPageload', false)
						 commit('setError', null)
						 
						 console.log('payload: charge',payload); 
						 
						 if(payload.charge !== undefined){
							//Create Charge for Paid user - after signup
							var Charge_IP = payload.charge;
							Charge_IP.uid = firebaseUser.user.uid;
							Charge_IP.stripeplan_id = payload.plan.stripeplan_id;
							Charge_IP.phonelists = payload.phonelists;
							console.log('Charge_IP',Charge_IP)
							dispatch('createChargeSignupPlan',Charge_IP).then(rep => {				
								 console.log('get createChargeSignupPlan success',rep)
							}).catch(validerr2 => {
								console.log('get createChargeSignupPlan error',validerr2)
							})
						}else{
							console.log('Free Account');
						}
						 router.push('/mydesk/home')						 
					}else{
						commit('setError', 'The User Not Valid')
						commit('setLoading', false)
						commit('setPageload', false)
					}
				}).catch(validerr => {
					console.log('get token validuser error',validerr)
				})
				
				
			}).catch(err => {
				 console.log(err)
				 commit('setError', err)
				 commit('setLoading', false)
				 commit('setPageload', false)
			})
			//create user obj
	  })
	  .catch(error => {
		commit('setError', error.message)
		commit('setLoading', false)
		commit('setPageload', false)
	  })
		  
    },
    createChargeSignupPlan ({ commit, dispatch, state }, payload){
		return new Promise((resolve, reject) => {
			payload.uid = state.user.uid
			//console.log('payload:',payload); 
			axios.post(`${window.endpoint}/firebase/users/plancharge`,payload).then(res => {
					//console.log('res',res);
					//this.$store.dispatch('paycheck',{email:this.useremail});		
					state.snack = true;
					state.snackColor = 'info';
					state.snackText = ' Plan Payment was completed!  You will receive details in email';
					resolve();
			}).catch(err => {
				//console.log('console err list  ', err) 
				resolve();
			})
				
		})//Promise  
    },
    userSignIn ({ commit, dispatch }, payload) {
      commit('setPageload', true)
      commit('setLoading', true)
      fb.auth.signInWithEmailAndPassword(payload.email, payload.password).then(firebaseUser => {
			//Add User Created Date & time
			//var RespData = {'createdate': moment(firebaseUser.user.metadata.creationTime).utc().format('YYYY-MM-DD HH:mm')};
			if(typeof payload.sid!=='undefined'){
				if(payload.sid!=''){
					var RespData = {'sid':payload.sid,'createdate': moment(firebaseUser.user.metadata.creationTime).valueOf()};
				}else{
					var RespData = {'createdate': moment(firebaseUser.user.metadata.creationTime).valueOf()};
				}
			}else{
				var RespData = {'createdate': moment(firebaseUser.user.metadata.creationTime).valueOf()};
			}
			//console.log('RespData',RespData)
			fb.db.collection('abitusers').doc(firebaseUser.user.uid).update(RespData).then(Resp => { }).catch(err => { })

			dispatch('validuser', { uid:firebaseUser.user.uid,redirect:'/mydesk/home' })	    
      })
      .catch(error => {
        commit('setError', error.message)
        commit('setLoading', false)
		commit('setPageload', false)
      })
    },
    autoSignIn ({commit, dispatch }, payload) {
		//Get User details from Cache code here
		var cuser = fb.auth.currentUser;
		if(cuser && localStorage.getItem("userdetails") && localStorage.getItem("userdetails") !== null ){	
			commit('setUser', JSON.parse(localStorage.getItem("userdetails")))
		}else{			
			if(cuser){
				dispatch('validuser', {uid:cuser.uid,redirect:''})
			}else{
				commit('setUser', null)
				localStorage.setItem("abittoken", null);
				localStorage.setItem("userdetails", null);
				localStorage.removeItem("abittoken");
				localStorage.removeItem("userdetails");
			}
		}
    },
    userSignOut ({commit}) {
      commit('setUser', null)
      localStorage.setItem("abittoken", null);
      localStorage.setItem("userdetails", null);
      fb.auth.signOut()
      router.push('/signin')
      location.reload();
    },
    validuser ({commit, dispatch}, payload) {
		//get user obj
	    fb.db.collection('abitusers').where('uid', '==', payload.uid).get()
			.then(snapshot => {
				var promises = [];
				snapshot.forEach(docs =>  {
					var DataSet = docs.data();
					DataSet['id']=docs.id
					promises.push(DataSet);
				});
				return Promise.all(promises);			
	    }).then(Resp => {
			//console.log('Resp validuser',Resp[0]);
			dispatch('gettoken',Resp[0]).then(token => {
				
				if(token){
					 localStorage.setItem("userdetails", JSON.stringify(Resp[0]));
					 commit('setUser', Resp[0])
					 dispatch('listUserNum', {uid:payload.uid,sid:''});
					 commit('setLoading', false)
					 commit('setError', null)
					 commit('setPageload', false)
					 if(payload.redirect){
						router.push(payload.redirect)
					 }else{
						// console.log('else');
						router.push('/') 
					 }
				}else{
					commit(' ', 'The User Not Valid')
					commit('setLoading', false)
					commit('setPageload', false)
				}
			}).catch(validerr => {
				//console.log('get token validuser error',validerr)
			})
		}).catch(err => {
			// console.log(err)
			 commit('setError', err)
			 commit('setLoading', false)
		})
	    //get user obj		  
    },
    getuser ({commit, dispatch}, payload) {
		commit('setPageload', true)
		commit('setLoading', true)
		//get user obj
	    fb.db.collection('abitusers').where('uid', '==', payload.uid).get()
			.then(snapshot => {
				var promises = [];
				snapshot.forEach(docs =>  {
					var DataSet = docs.data();
					DataSet['id']=docs.id
					promises.push(DataSet);
				});
				return Promise.all(promises);			
	    }).then(Resp => {
			 //console.log('Resp validuser',Resp[0]);
			 localStorage.setItem("userdetails", JSON.stringify(Resp[0]));
			 commit('setUser', Resp[0])
			 commit('setLoading', false)
			 commit('setPageload', false)
					 
		}).catch(err => {			
			 commit('setLoading', false)
			 commit('setPageload', false)
		})
	    //get user obj		  
    },
	setSlackData({ commit, dispatch }, payload) {
		 console.log('setSlackData',payload)
		if(typeof payload.sid!=='undefined' && typeof payload.uid!=='undefined'){
			if(payload.sid!=''){
				var RespData = {'sid':payload.sid}; console.log('StoreRespData',RespData)
				fb.db.collection('abitusers').doc(payload.uid).update(RespData).then(Resp => { }).catch(err => { })
				dispatch('validuser', { uid:payload.uid,redirect:'/slack' })
			}
		}
				 
	},
	
	
	
  //Projects & lists
   getprojects ({ commit, dispatch, state }, payload) {
	  if(state.user  != null && state.user != undefined && state.user  != ''){	 
		 var uid =state.user.uid;
		 if(uid){	
		 	 axios.post(`${window.endpoint}/securereminder/getprojectlist`, { useremail: state.user.emailaddress ,uid: uid}) 
			 .then((res) => {		
					if(res.data.error==false){
						 state.projectlist = res.data.rows;	
					}
			}).catch(err => {

			});
			 
			 
			 
			 
		 }
	  }
	},
	
	  /* Subscriptions */
    getsubscriptionslist ({ commit, dispatch, state }, payload) {
		//axios.defaults.headers.common['Authorization'] =  'Bearer ' + localStorage.getItem('abittoken');
        axios.post(`${window.endpoint}/securereminder/getpurchasedservices`,  payload ).then(dataset => { 
           state.subscriptionslist = dataset.data.rows
        }).catch(err => {
			
		})
	 },	
	 /* Subaccount */
    getsubaccountlist ({ commit, dispatch, state }, payload) {
		//getv
		if(typeof payload !=='undefined'){
			commit('setLoading', true)				
			var uid =state.user.uid;
			if(uid){
				 axios.defaults.headers.common['Authorization'] =  'Bearer ' + localStorage.getItem('abittoken');
				 axios.get(`${window.devendpoint}/firebase/users/list-subaccount/`+uid).then((res) => {	
					 if(res.data.rows){
						state.listsubaccount = res.data.rows;	
						if(typeof payload.getchatlogs !=='undefined'){
						   if( payload.getchatlogs == true){
							dispatch('getsubaccountchatlogs');
						   }
						}
					 }else{
						state.listsubaccount = []; 
					 }
					 commit('setLoading', false)			
				}).catch(err => {	console.log(err);commit('setLoading', false);	});
			 }
		}
		//getv
	 },	
	 //subaccount kafka - chat logs
    getsubaccountchatlogs ({ commit, dispatch, state }, payload) {
		//getv
		commit('setLoading', true)				
		var uid =state.user.uid;
		if(uid){
			 axios.defaults.headers.common['Authorization'] =  'Bearer ' + localStorage.getItem('abittoken');
			 axios.get(`${window.devendpoint}/endpoint/lastmessage/`+uid).then((res) => {	
				 if(res.data.rows){
					var inchatlogs = res.data.rows;	
					//console.log('inchatlogs',inchatlogs);
					//console.log('listsubaccount',state.listsubaccount);
					
					var listsubaccount = state.listsubaccount.filter(function (e) {						
						//e.subuid == i.room
						var getlogs = inchatlogs.filter(function (i) { return e.subuid == i.subaccount_uid ; });						
						if(getlogs[0] !== undefined){
							e.chatlogs = getlogs[0].mes[0];
						}else{
							e.chatlogs = { 'createdat': "1970-01-01T00:00:00.000Z"  }
						}
						return e;										
					});	
					state.inchatlogs = listsubaccount.sort(function(a, b) {
						var dateA = new Date(a.chatlogs.createdat).getTime();
						var dateB = new Date(b.chatlogs.createdat).getTime(); 
						//return dateA > dateB ? 1 : -1;   //ascending
						return dateA > dateB ? -1 : 1;   //descending 
					});				
					
				 }else{
					state.inchatlogs = []; 
				 }
				 commit('setLoading', false)			
			}).catch(err => {	console.log(err);commit('setLoading', false);	});
		 }
		//getv
	 },	
    getsubaccountchatlogs2 ({ commit, dispatch, state }, payload) {
		//getv
		commit('setLoading', true)				
		var uid =state.user.uid;
		if(uid){
			 axios.defaults.headers.common['Authorization'] =  'Bearer ' + localStorage.getItem('abittoken');
			 axios.get(`${window.devendpoint}/inbrowser/chatlogs/`+uid).then((res) => {	
				 if(res.data.rows){
					var inchatlogs = res.data.rows;	
					//console.log('inchatlogs',inchatlogs);
					//console.log('listsubaccount',state.listsubaccount);
					
					var listsubaccount = state.listsubaccount.filter(function (e) {						
						//e.subuid == i.room
						var getlogs = inchatlogs.filter(function (i) { return e.subuid == i.room ; });						
						if(getlogs[0] !== undefined){
							e.chatlogs = getlogs[0];
						}else{
							e.chatlogs = { 'created': "1970-01-01T00:00:00.000Z"  }
						}
						return e;										
					});	
					state.inchatlogs = listsubaccount.sort(function(a, b) {
						var dateA = new Date(a.chatlogs.created).getTime();
						var dateB = new Date(b.chatlogs.created).getTime(); 
						//return dateA > dateB ? 1 : -1;   //ascending
						return dateA > dateB ? -1 : 1;   //descending 
					});				
					
				 }else{
					state.inchatlogs = []; 
				 }
				 commit('setLoading', false)			
			}).catch(err => {	console.log(err);commit('setLoading', false);	});
		 }
		//getv
	 },	
	/*Calendar Events - Meetings*/
	getCalendarMeetings ({ commit, dispatch, state }, payload) {
		state.selectedEvent =	payload.selectedEvent
		state.events = []; 
		if( payload.mid !== undefined && payload.mid !== null && payload.mid !== ""){
			commit('setPageload', true)
			axios.defaults.headers.common['Authorization'] =  'Bearer ' + localStorage.getItem('abittoken');
			axios.get(`${window.devendpoint}/firebase/users/getmeetings/?mid=` + payload.mid ).then(dataset => {
			   //console.log('console addRemainder ', dataset)
				commit('setPageload', false)
				if(dataset.data){
					state.events = dataset.data.rows;	
				}else{
					state.events = []; 
				}
			}).catch(err => { commit('setPageload', false); console.log('console err getCalendarMeetings ', err); })
		}
     },	
	/*Calendar Events - Meetings*/
	 			
    /*Services add/update Ends*/
     addServices ({ commit, dispatch, state }, payload) {
		 commit('setLoading', true)
		 axios.defaults.headers.common['Authorization'] =  'Bearer ' + localStorage.getItem('abittoken');
        axios.post(`${window.endpoint}/reminder/notifications/add-services`, payload , { headers: { 	'Content-Type': 'multipart/form-data' }   } ).then(dataset => {
           //console.log('console addRemainder ', dataset)
           commit('setLoading', false)
          // state.serviceadddialogue = false; //Close popup on Blog to listing Post
           dispatch('listServices', {uid: state.user.uid })
		   console.log('k',dataset.data.id);
		   state.knowledge.id = dataset.data.id
        }).catch(err => { commit('setLoading', false); console.log('console err addRemainder ', err); })
     },
     listServices ({ commit, state }, payload) {
		 
		commit('setListLoading', true)
		 axios.defaults.headers.common['Authorization'] =  'Bearer ' + localStorage.getItem('abittoken');
        axios.get(`${window.devendpoint}/reminder/notifications/list-services/${payload.uid}?type=${payload.type}`, payload).then(dataset => {
           //console.log('console listRemainder ', dataset.data.rows)
           commit('setListLoading', false)
           commit('setRemainders', dataset.data.rows)
		   state.knowledgelist = dataset.data.rows
        }).catch(err => { commit('setListLoading', false); console.log('console err listRemainder ', err) })
     },
    
     /*Database creation for tables*/
    adddefaultdb({ commit, state }, payload) {
		
		commit('setPageload', true)
		//var uid =state.user.uid;
		 if(state.user.Type == 'Subaccount'){
			var uid = state.user.primaryuid
		 }else{
			var uid = state.user.uid;
		 }
		axios.defaults.headers.common['Authorization'] =  'Bearer ' + localStorage.getItem('abittoken');
		axios.post(`${window.devendpoint}/todo/get_databases_resu/`+uid).then(function(response){ 
			//console.log('robo**',response);
			commit('setPageload', false)
			if(typeof response.data.dbid!=='undefined'){
			state.selecteddb=response.data.dbid;
			}
		}).catch(err=>{
			console.log('robo**',err);
			commit('setPageload', false)
		})
		 
	 },
    getdblist({ commit, state }, payload) {
		
		commit('setPageload', true)
		//var uid =state.user.uid;
		 if(state.user.Type == 'Subaccount'){
			var uid = state.user.primaryuid
		 }else{
			var uid = state.user.uid;
		 }
		 var limit=10; var searchkey=""; var page=1;
		axios.defaults.headers.common['Authorization'] =  'Bearer ' + localStorage.getItem('abittoken');
		axios.post(`${window.devendpoint}/todo/get_databases/`+uid+`/`+page+`/`+limit+`/`+searchkey).then(function(response){ 
			console.log('refresh',response)
			commit('setPageload', false)
			if(typeof response.data.rows[0] !=='undefined'){
				 state.dblist=response.data.rows;
			}
		}).catch(err=>{
			console.log('robo**',err);
			commit('setPageload', false)
		})
		 	 
		 
	 },
    
    /*User Signup/Signin Ends*/
    /*Q/A starts Jan 2019 */
     listImages ({ commit, state }, payload) {		 
		commit('setLoading', true)
		//axios.defaults.headers.common['Authorization'] =  'Bearer ' + localStorage.getItem('abittoken');
        axios.get(`${window.endpoint}/reminder/notifications/listall-photos`, payload).then(dataset => {
           state.listimages = dataset.data.rows
           commit('setLoading', false)
        }).catch(err => { commit('setLoading', false); console.log('console err list  ', err) })
    },
    approveImage ({ commit, dispatch, state }, payload) {
		commit('setLoading', true)
		//axios.defaults.headers.common['Authorization'] =  'Bearer ' + localStorage.getItem('abittoken');
        axios.post(`${window.endpoint}/reminder/notifications/approve-photos`, payload).then(dataset => {
           console.log('console approveImage ', dataset )
           setTimeout(function () { dispatch('listImages', {uid: state.user.uid })  }, 2000)
        }).catch(err => { console.log('console err approveImage ', err) })
    },
    
    twiliolistResponse ({ commit, state }, payload) {
		 
		commit('setLoading', true)
		 axios.defaults.headers.common['Authorization'] =  'Bearer ' + localStorage.getItem('abittoken');
        axios.get(`${window.devendpoint}/reminder/notifications/listtwilio-response`, payload).then(dataset => {
           state.twilioresponse = dataset.data.rows
           commit('setLoading', false)
        }).catch(err => { commit('setLoading', false); console.log('console err listtwilio  ', err) })
    },
    mapResponse ({ commit, dispatch, state }, payload) {
		 
		commit('setLoading', true)
		 axios.defaults.headers.common['Authorization'] =  'Bearer ' + localStorage.getItem('abittoken');
        axios.post(`${window.devendpoint}/reminder/notifications/maptwilio-response`, payload).then(dataset => {
           //state.twilioresponse = dataset.data.rows
           //commit('setLoading', false)
           setTimeout(function () { dispatch('twiliolistResponse', {uid: state.user.uid })  }, 3000)
           
        }).catch(err => { commit('setLoading', false); console.log('console err listtwilio  ', err) })
    },
    addResponse ({ commit, dispatch, state }, payload) {
		
		 console.log('console addResponse called ')
		 
		 commit('setLoading', true)
		 axios.defaults.headers.common['Authorization'] =  'Bearer ' + localStorage.getItem('abittoken');
        axios.post(`${window.devendpoint}/reminder/notifications/add-response`, payload , { headers: { 	'Content-Type': 'multipart/form-data' }   } ).then(dataset => {
           console.log('console addResponse ', dataset)
           commit('setLoading', false)
        }).catch(err => { commit('setLoading', false); console.log('console err add   ', err); })
     },
     listResponse ({ commit, state }, payload) {
		 
		commit('setLoading', true)
		 axios.defaults.headers.common['Authorization'] =  'Bearer ' + localStorage.getItem('abittoken');
        axios.get(`${window.devendpoint}/reminder/notifications/listall-response`, payload).then(dataset => {
           state.questionresponse = dataset.data.rows
           commit('setLoading', false)
        }).catch(err => { commit('setLoading', false); console.log('console err list  ', err) })
    },
    approveResponse ({ commit, dispatch, state }, payload) {
		commit('setLoading', true)
		 axios.defaults.headers.common['Authorization'] =  'Bearer ' + localStorage.getItem('abittoken');
        axios.post(`${window.devendpoint}/reminder/notifications/approve-response`, payload).then(dataset => {
           console.log('console approveResponse ', dataset )
           setTimeout(function () { dispatch('listResponse', {uid: state.user.uid })  }, 2000)
        }).catch(err => { console.log('console err approveResponse ', err) })
    },
    addQuestions ({ commit, dispatch, state }, payload) {
		 commit('setLoading', true)
		axios.defaults.headers.common['Authorization'] =  'Bearer ' + localStorage.getItem('abittoken');
        axios.post(`${window.endpoint}/reminder/notifications/add-questions`, payload , { headers: { 	'Content-Type': 'multipart/form-data' }   } ).then(dataset => {
           console.log('console addQuestions ', dataset)
           setTimeout(function () {	dispatch('listQuestions', {uid: state.user.uid })  }, 2000)
        }).catch(err => { commit('setLoading', false); console.log('console err add  ', err); })
     },
     listQuestions2 ({ commit, dispatch, state }, payload) {
		 
		commit('setLoading', true)
		 axios.defaults.headers.common['Authorization'] =  'Bearer ' + localStorage.getItem('abittoken');
        axios.get(`${window.devendpoint}/reminder/notifications/listall-questions`, payload).then(dataset => { 
           state.questions = dataset.data.rows
           commit('setLoading', false)
           dispatch('listResponse', {uid: state.user.uid })
        }).catch(err => { commit('setLoading', false); console.log('console err list  ', err) })
     },
    /*Q/A ends Jan 2019 */
	
	//callforward callfwd
	  
	 addCallfwd ({ commit, dispatch, state }, payload) {
		return new Promise((resolve, reject) => {	 
			 axios.defaults.headers.common['Authorization'] =  'Bearer ' + localStorage.getItem('abittoken');
			 axios.post(`${window.devendpoint}/phonenumber/add-user-phonenumb`, payload , { headers: { 	'Content-Type': 'multipart/form-data' }   } ).then(dataset => {
																									  
			    resolve(dataset); 
			 }).catch(err => { 
				console.log('console err add   ', err); 
				 reject(err);
			})
			//setTimeout(function () {	  resolve('');   }, 2000)
		 })
     },
     listUserNum ({ commit, dispatch, state }, payload) {
		 //axios.defaults.headers.common['Authorization'] =  'Bearer ' + localStorage.getItem('abittoken');
        
		//console.log('listCallfwd:',state.tomenuid);
		if(state.uid!==''){
			
			
			//chat
			 if(state.user.Type=='Subaccount'){
				state.chroom=state.user.primaryuid
			 }else{
				state.chroom=state.user.id
			 }
			
			//state.indeterminate=false;
			axios.defaults.headers.common['Authorization'] =  'Bearer ' + localStorage.getItem('abittoken');
			axios.post(`${window.devendpoint}/phonenumber/list-user-phonenumb`,  payload ).then(dataset => { 
			   //state.listCallfwd = dataset.data.rows
			   if(typeof dataset.data.rows[0]  !== "undefined") {
				   //state.callfwd = dataset.data.rows[0];
				   state.from = dataset.data.rows[0].phoneNumber;
				   state.tomenuid= dataset.data.rows[0].id;
				   state.dfrom = dataset.data.rows[0].phoneNumber;
				   state.dtomenuid= dataset.data.rows[0].id;
				   
				    /*var groupid=payload.uid+'-default-mobile-group';
					var topic1=state.from.replace("+", "topic"); var topic='mobile-'+topic1;
				    axios.get(`${window.endpoint}/gatewayc2/kafka-subscribe-mobile/`+topic+`/`+groupid, {} ).then(dataset => {					
						console.log('###Subscribed to '+topic+'');
					}).catch(err => {  	})*/
				   
				   
			   }
			}).catch(err => { commit('setLoading', false); console.log('console err list  ', err) })
		}
     },listCallfwd ({ commit, dispatch, state }, payload) {
		 //axios.defaults.headers.common['Authorization'] =  'Bearer ' + localStorage.getItem('abittoken');
        
		//console.log('listCallfwd:',state.tomenuid);
		//state.indeterminate=false;
		axios.defaults.headers.common['Authorization'] =  'Bearer ' + localStorage.getItem('abittoken');
		axios.post(`${window.devendpoint}/phonenumber/list-user-phonenumb`,  payload ).then(dataset => { 
           //state.listCallfwd = dataset.data.rows
		   if(typeof dataset.data.rows[0]  !== "undefined") {
			   state.callfwd = dataset.data.rows[0];
			   state.from = dataset.data.rows[0].phoneNumber;
			   state.tomenuid= dataset.data.rows[0].id;
			   
			   if(state.tomenuid==""){
				   state.tomenuid= dataset.data.rows[0].id;   console.log('star:',state.tomenuid);
				    state.tomenutype ='sms';
					//state.indeterminate=false;
				   //store.dispatch('listSms',{to:'',uid:state.user.uid});
				   router.push('/voip-conversations/'+dataset.data.rows[0].id+'/sms')	
			   }
			   
		   }
        }).catch(err => { commit('setLoading', false); console.log('console err list  ', err) })
     },
     listallCallfwd ({ commit, dispatch, state }, payload) {
		 axios.defaults.headers.common['Authorization'] =  'Bearer ' + localStorage.getItem('abittoken');
        axios.post(`${window.devendpoint}/phonenumber/list-user-phonenumb`,  payload ).then(dataset => { 
           //state.listCallfwd = dataset.data.rows
		   
		  		 if(state.user.Type=='Subaccount'){
					/* if(typeof dataset.data.rows[0]  !== "undefined") {
						state.listCallfwd = dataset.data.rows[0]
					 }*/
					 if(typeof state.user.sms_privilegedata  !== "undefined") {
						state.listCallfwd = state.user.sms_privilegedata
					 }
				 }else{
					state.listCallfwd = dataset.data.rows
					
					   if(typeof dataset.data.rows[0]  !== "undefined" &&  state.callfwd.sid=="") { //new 2020
						   state.callfwd = dataset.data.rows[0];
						   state.from = dataset.data.rows[0].phoneNumber;
						   state.tomenuid =dataset.data.rows[0].id;  
					   }
				 }
				 
				  if(typeof payload.psid  !== "undefined" && payload.psid!='' && state.listCallfwd.length>0) { 
				 	 if(payload.psid  !== "all") { 
				  				console.log('payload psid:',payload.psid); 
								var filterPhone = state.listCallfwd.filter(function (e) {
									return e.id == payload.psid;
								});
								console.log('filterPhone  ', filterPhone)
								if(typeof filterPhone[0]  !== "undefined"){
									if(typeof filterPhone[0].phoneNumber  !== "undefined"){
										console.log(filterPhone[0].phoneNumber);
										state.from =filterPhone[0].phoneNumber; 
										state.to = ''; 
									}
								}
					 }
				  
				  }else if(state.from=='' && state.listCallfwd.length>0) { 
				  	  console.log('*********',state.listCallfwd[0].phoneNumber);
					  if(typeof state.listCallfwd[0].phoneNumber  !== "undefined"){
							state.from =state.listCallfwd[0].phoneNumber; 
							state.to = '';  
							state.tomenuid =state.listCallfwd[0].id;  
							//router.push('/voip-conversations/'+state.listCallfwd[0].id+'/sms')		
					  }
				  }
        }).catch(err => { commit('setLoading', false); console.log('console err list  ', err) })
     },
	 
	 scheduleCallfwd ({ commit, dispatch, state }, payload) {
		return new Promise((resolve, reject) => {	 
							console.log('scheduleCallfwd',payload);
			  axios.defaults.headers.common['Authorization'] =  'Bearer ' + localStorage.getItem('abittoken');
			 axios.post(`${window.devendpoint}/phonenumber/schedule-call-fwd`,{json:JSON.stringify(payload)} ).then(dataset => {																				  
			    resolve(dataset); 
			 }).catch(err => { 
				 console.log('console err add   ', err); 
				 reject(err);
			})
			//setTimeout(function () {	  resolve('');   }, 2000)
		 })
     },listscheduleCallfwd ({ commit, dispatch, state }, payload) {
		// payload.sid='PNaeea8405be8bc49e1445d261dce14f5b'; 
		 axios.defaults.headers.common['Authorization'] =  'Bearer ' + localStorage.getItem('abittoken');
         axios.post(`${window.devendpoint}/phonenumber/listall-schedule-call-fwd`,  payload ).then(dataset => { 
		   state.voipevents = dataset.data.rows
         }).catch(err => {  
			 console.log('console err list  ', err) 
		 })
     },
	
	//callforward
	
	
	//Conference
	addConference ({ commit, dispatch, state }, payload) {
		return new Promise((resolve, reject) => {
			 axios.defaults.headers.common['Authorization'] =  'Bearer ' + localStorage.getItem('abittoken');
			axios.post(`${window.devendpoint}/securereminder/add-conference`, payload , { headers: { 	'Content-Type': 'multipart/form-data' }   } ).then(dataset => {
			   // console.log('console addConference ', dataset); state.selconflist =dataset;
			    setTimeout(function () {	  dispatch('listConference', {uid: state.user.uid  }).then(dataset => { state.confsadddialogue =false;  resolve(dataset);   console.log('completed'); });   }, 2000)
			   
			}).catch(err => { 
				reject(err); 
				console.log('console err add   ', err); 
			})
		 })
     },
     listConference ({ commit, dispatch, state }, payload) {
		  axios.defaults.headers.common['Authorization'] =  'Bearer ' + localStorage.getItem('abittoken');
         axios.post(`${window.devendpoint}/securereminder/listall-conference`,  payload ).then(dataset => { 
           state.conflist = dataset.data.rows
		   
		  			if(dataset.data.rows[0] === undefined || dataset.data.rows[0] === null || dataset.data.rows[0] !== ''){  
						console.log('*********--');
						state.selconflist = { id:'',  opencalldate: new Date().toISOString().substr(0, 10) , opencall:'Yes',location:'Yes',seatLtd:'Yes',passPro:'Yes',recordConf:'No',sendUrl:'No',phonenumbers:'+917904166914,+916379112113'};
					}else {
						console.log('*********');
						 state.selconflist = dataset.data.rows[0];
					}
		   
		   
         }).catch(err => { commit('setLoading', false); console.log('console err list  ', err) })
     },
	 //Conference end
	 
	 //Templates
	 listTemplateCat ({ commit, state }, payload) {
		 
		payload.uid=state.user.uid;
		commit('setLoading', true)
		 axios.defaults.headers.common['Authorization'] =  'Bearer ' + localStorage.getItem('abittoken');
        axios.post(`${window.devendpoint}/securereminder/list-tempgroup`, payload).then(dataset => {
           state.templatecat = dataset.data.rows
        }).catch(err => {   console.log('console err list  ', err) }) 
     },listTemplates ({ commit, state }, payload) {
		 
		payload.uid=state.user.uid;
		commit('setLoading', true)
		 axios.defaults.headers.common['Authorization'] =  'Bearer ' + localStorage.getItem('abittoken');
        axios.post(`${window.devendpoint}/securereminder/list-template`, payload).then(dataset => {
           state.templatelist = dataset.data.rows
        }).catch(err => {   console.log('console err list  ', err) }) 
     },
	 
	 
	 //SMS
     listSms ({ commit, dispatch, state }, payload) {
		if(state.user.Type == 'Subaccount'){ 	var uid = state.user.primaryuid;  }else{ 	var uid = state.user.uid;  }
		payload.uid=uid;
		
		payload.MasterPhone=state.from;
		
		//console.log('listSms',payload);
		 axios.defaults.headers.common['Authorization'] =  'Bearer ' + localStorage.getItem('abittoken');
        axios.post(`${window.devendpoint}/gatewayc2/list-sms`, payload).then(dataset => {
		   //console.log(dataset.data.rows.length);
           state.smsevents  = dataset.data.rows
		   dispatch('listAllSms', payload).then(dataset => { 	}); 
        }).catch(err => { 
		console.log('console err list  ', err) 
		}) 
    },
	listAllSms ({ commit, dispatch, state }, payload) {
		
		if(state.user.Type == 'Subaccount'){ 	var uid = state.user.primaryuid;  }else{ 	var uid = state.user.uid;  }
		payload.uid=uid;
		
		//payload.MasterPhone=state.from;
		
		// console.log('listAllSms......',payload);
		axios.defaults.headers.common['Authorization'] =  'Bearer ' + localStorage.getItem('abittoken');
        axios.post(`${window.devendpoint}/gatewayc2/listall-sms`, payload).then(dataset => {
		   //console.log(dataset.data.rows.length);
		   state.eventmobile = dataset.data.mobile
		   state.eventstatus= dataset.data.status
		   state.recentmsg= dataset.data.rows
		   
		  /* state.totalconversation= dataset.data.total;				
		   if(dataset.data.total>=10){
				state.totalconversation= 1000;
		   }*/
		   
		  // console.log('stateto:'+state.to);
			 if(typeof state.eventmobile[0]  !== "undefined" && state.to=='') { 
				  if(typeof state.eventmobile[0].top_rated_hits.hits.hits[0]._source.to  !== "undefined" && state.to=='') {
					  //conv
					  /*var sstatus= state.eventmobile[0].top_rated_hits.hits.hits[0]._source.status
					  var sfrom= state.eventmobile[0].top_rated_hits.hits.hits[0]._source.from
					  var sto =state.eventmobile[0].top_rated_hits.hits.hits[0]._source.to
					
					   state.to=sto;
					   dispatch('listSms',{to:sto,uid:uid});*/ //listSms
					   //conv
				  }
			 }
			 
			   dispatch('listAllPhoneSms', {uid: state.user.uid ,to: state.user.to }).then(dataset => { });
		   
		   
        }).catch(err => { 
		//console.log('console err list  ', err) 
		}) 
    },
	listAllPhoneSms ({ commit, dispatch, state }, payload) {
		if(state.user.Type == 'Subaccount'){ 	var uid = state.user.primaryuid;  }else{ 	var uid = state.user.uid;  }
		payload.uid=uid;

		payload.MasterPhone='all';
		
		//console.log('listAllPhoneSms',payload);
		axios.defaults.headers.common['Authorization'] =  'Bearer ' + localStorage.getItem('abittoken');
        axios.post(`${window.devendpoint}/gatewayc2/listall-sms?id=2`, payload).then(dataset => {
		  
		  //console.log('totalconversation1:',dataset.data.total);
		  state.totalconversation= dataset.data.total;				
		   if(typeof state.user.plans  !== "undefined") {
			   if(dataset.data.total>=state.user.plans.sms_count){
					//state.totalconversation= 1000;
					clearInterval(state.timer);
			   }
		   }
		   //console.log('totalconversation2:',state.totalconversation);
        }).catch(err => { 
		//console.log('console err list  ', err) 
		}) 
    },
	
	//Collections
	 addCollections ({ commit, dispatch, state }, payload) {
		
		 console.log('console addResponse called ')
		 
		 commit('setLoading', true)
		axios.defaults.headers.common['Authorization'] =  'Bearer ' + localStorage.getItem('abittoken');
        axios.post(`${window.devendpoint}/securereminder/add-collections`, payload , { headers: { 	'Content-Type': 'multipart/form-data' }   } ).then(dataset => {
           console.log('console addResponse ', dataset)
          
		   setTimeout(function () {	 
				dispatch('listCollections', {uid: state.user.uid  }).then(dataset => {
					state.collectionsadddialogue =false;
					console.log('completed');
					 commit('setLoading', false)
				});
				  
			}, 2000)
        }).catch(err => { commit('setLoading', false); console.log('console err add   ', err); })
     },
     listSongs ({ commit, state }, payload) {
		 
		payload.uid=state.user.uid;
		commit('setLoading', true)
		axios.defaults.headers.common['Authorization'] =  'Bearer ' + localStorage.getItem('abittoken');
        axios.post(`${window.devendpoint}/securereminder/list-songs`, payload).then(dataset => {
           state.collectionsongs = dataset.data.rows
           //commit('setLoading', false)
        }).catch(err => { commit('setLoading', false); console.log('console err list  ', err) }) 
    },
     listFav ({ commit, state }, payload) {
		 
		payload.uid=state.user.uid;
		commit('setLoading', true)
		axios.defaults.headers.common['Authorization'] =  'Bearer ' + localStorage.getItem('abittoken');
        axios.post(`${window.devendpoint}/securereminder/list-favourite`, payload).then(dataset => {
           state.collectionfavsongs = dataset.data.rows
           //commit('setLoading', false)
        }).catch(err => { commit('setLoading', false); console.log('console err list  ', err) }) 
    },
     addToPlaylist ({ commit, state }, payload) {
		 
		  state.aplayerlist.push(Vue.util.extend({}, payload));
    },
     removeToPlaylist ({ commit, state }, payload) {
		 
		  state.aplayerlist.pop(Vue.util.extend({}, payload));
    } ,
    addSongs ({ commit, dispatch, state }, payload) {
		 commit('setLoading', true)
		 axios.defaults.headers.common['Authorization'] =  'Bearer ' + localStorage.getItem('abittoken');
         axios.post(`${window.devendpoint}/securereminder/add-songs`, payload , { headers: { 	'Content-Type': 'multipart/form-data' }   } ).then(dataset => {
           console.log('console addCollections ', dataset)
           setTimeout(function () {	 
			
				dispatch('listSongs', {uid: state.user.uid ,collectionid: state.currentcollections.id }).then(dataset => {
					 state.collectionssongsdialogue =false;
					 console.log('completed');
					 commit('setLoading', false)
				}); 
			
			
			
			}, 2000)
        }).catch(err => { commit('setLoading', false); console.log('console err add  ', err); })
     },
     listCollections ({ commit, dispatch, state }, payload) {
		commit('setPageload', true)
		commit('setLoading', true)
		axios.defaults.headers.common['Authorization'] =  'Bearer ' + localStorage.getItem('abittoken');
        axios.post(`${window.devendpoint}/securereminder/listall-collections`,  {useremail: state.user.emailaddress , uid: state.user.uid } ).then(dataset => { 
           state.collections = dataset.data.rows
           commit('setLoading', false)
           commit('setPageload', false)
           //setTimeout(function () { dispatch('listSongs', {uid: state.user.uid ,collectionid: state.currentcollections.id })  }, 2000)
        }).catch(err => { commit('setLoading', false); commit('setPageload', false);console.log('console err list  ', err) })
     },
     listSingleCollections ({ commit, dispatch, state }, payload) {
		 
		commit('setLoading', true) 
		console.log(payload.collectionid);
		axios.defaults.headers.common['Authorization'] =  'Bearer ' + localStorage.getItem('abittoken');
        axios.post(`${window.devendpoint}/securereminder/listall-collections`,  {uid: 'all',id: payload.collectionid  } ).then(dataset => { 
            if(typeof dataset.data.rows[0]  !== "undefined") {
		  	 state.currentcollections = dataset.data.rows[0];
			}
          // commit('setLoading', false)
           //setTimeout(function () { dispatch('listSongs', {uid: state.user.uid ,collectionid: state.currentcollections.id })  }, 2000)
        }).catch(err => { commit('setLoading', false); console.log('console err list  ', err) })
     },
    /*Collections ends Feb 2019 */
 
	/*Objectmodel listing*/
	listOM ({ commit, dispatch, state }, payload) {
	  return new Promise((resolve, reject) => {
		 var itemid = '';
		 if(payload.id !== undefined && payload.id != ''){
			 itemid = payload.id;
		 } 
		commit('setPageload', false); commit('setLoading', false);
		axios.defaults.headers.common['Authorization'] =  'Bearer ' + localStorage.getItem('abittoken');
        axios.post(`${window.devendpoint}/firebase/users/objectmodellist/`+payload.uid+'/'+payload.pagelength+'/'+payload.pagecount,{id:itemid} ).then(dataset => { 
           state.ObjectmodelList = dataset.data.rows
           if(payload.id !== undefined && payload.id != ''){
			   state.selectedobjectsadditem = dataset.data.rows[0];
			   //~ var Fieldset = state.selectedobjectsadditem.fields;
			   //~ var newArray =[];
				//~ Fieldset.forEach((v, i) => {
					//~ var filename =v.value.structure.column_name;
					//~ newArray[v.value.structure.column_name] = '';
				//~ });
				
				//~ state.selectedOMmodel = newArray;
				//~ console.log('newArray',newArray);
		   }
           if(dataset.data.rows.length>0){
           	state.ObjectmodelLength=dataset.data.rows[0].full_count;	
           }
           commit('setLoading', false)
           commit('setPageload', false)
           resolve('resolved'); 
        }).catch(err => { resolve('Error with resolved'); commit('setLoading', false); commit('setPageload', false);console.log('console err list  ', err) })
        
       })//Promise	
        
     }, 
	listSites ({ commit, dispatch, state }, payload) {
		commit('setPageload', false); commit('setLoading', false);
		axios.defaults.headers.common['Authorization'] =  'Bearer ' + localStorage.getItem('abittoken');
        axios.get(`${window.devendpoint}/securereminder/listall-sites/`+payload.uid+'/'+payload.pagecount+'/'+payload.pagelength ).then(dataset => { 
           state.sitedata = dataset.data.rows
           if(dataset.data.rows.length>0){
           	state.sitedatalength=dataset.data.rows[0].full_count;	
           }
		   dispatch('listSiteCat', {uid: state.user.uid})
           commit('setLoading', false)
           commit('setPageload', false)
        }).catch(err => { commit('setLoading', false); commit('setPageload', false);console.log('console err list  ', err) })
     },
 	 listSiteCat ({ commit, dispatch, state }, payload) {
			commit('setPageload', false); commit('setLoading', false);
			var uid =state.user.uid;
			axios.defaults.headers.common['Authorization'] =  'Bearer ' + localStorage.getItem('abittoken');
			console.log('listsel-sites:',`${window.devendpoint}/securereminder/listsel-sites/all/`+uid);
			axios.post(`${window.devendpoint}/securereminder/listsel-sites/all/`+uid).then(dataset => { 
				 if(dataset.data.rows.length>0){
					state.SelCategoryList= dataset.data.rows;
			     }
			   commit('setLoading', false)
			   commit('setPageload', false)
			}).catch(err => { commit('setLoading', false); commit('setPageload', false);console.log('console err list  ', err) })
      },
	 listselCat ({ commit, dispatch, state }, payload) {
		commit('setPageload', false); commit('setLoading', false);
		axios.defaults.headers.common['Authorization'] =  'Bearer ' + localStorage.getItem('abittoken'); 
		axios.post(`${window.devendpoint}/securereminder/listsel-sites/${payload.siteid}`,{uid:payload.uid,todotitle_id:'details',id:payload.siteid}).then(dataset => {
           if(dataset.data.rows.length>0){
                var Resp =dataset.data.rows[0].categories;
				var filtered = Resp.filter(function (el) {
				  return el != null;
				});
				var filtered2 = filtered.filter(function (el) {
				  
				  return el.status==1 && e1.title!="New Category";
				});
				
				
				dataset.data.rows[0].categories = filtered2
				state.CategoryList= filtered2;
           }
           commit('setLoading', false)
           commit('setPageload', false)
        }).catch(err => { commit('setLoading', false); commit('setPageload', false);console.log('console err list  ', err) })
     },
	
	
	/*2020 Forms*/
	listFormFilter ({ commit, dispatch, state }, payload) {				
		var uid =state.user.uid;
		if(uid){
			 axios.defaults.headers.common['Authorization'] =  'Bearer ' + localStorage.getItem('abittoken');
			 axios.get(`${window.devendpoint}/todo/getform_list/`+uid).then((res) => {	
				 if(res.data.rows){
					state.listforms = res.data.rows;	
				 }else{
					state.listforms = []; 
				 }
			}).catch(err => {	
				console.log(err);commit('setLoading', false);	
			});
		 }
	 },	
	listForms ({ commit, dispatch, state }, payload) {
		commit('setPageload', false); commit('setLoading', false);
		axios.defaults.headers.common['Authorization'] =  'Bearer ' + localStorage.getItem('abittoken');
        axios.get(`${window.devendpoint}/securereminder/listall-forms/`+payload.uid+'/'+payload.pagecount+'/'+payload.pagelength ).then(dataset => { 
           state.formdata = dataset.data.rows
           if(dataset.data.rows.length>0){
           	state.datalength=dataset.data.rows[0].full_count;	
           }
           commit('setLoading', false)
           commit('setPageload', false)
        }).catch(err => { commit('setLoading', false); commit('setPageload', false);console.log('console err list  ', err) })
     },
 	 listQuestions ({ commit, dispatch, state }, payload) {
			commit('setPageload', false); commit('setLoading', false);
			axios.defaults.headers.common['Authorization'] =  'Bearer ' + localStorage.getItem('abittoken');
			
			if(typeof payload.pagecount=='undefined'){
				 payload.pagecount=1
			}
			if(typeof payload.pagelength=='undefined'){
				 payload.pagelength=10
			}
			
			axios.post(`${window.devendpoint}/securereminder/listall-questions/`+payload.uid+'/'+payload.pagecount+'/'+payload.pagelength,  payload ).then(dataset => { 
			   state.formdata = dataset.data.rows
			   state.questiondata = dataset.data.rows
			   if(dataset.data.rows>0){
				state.datalength=dataset.data.rows[0].full_count;
			   }
			   commit('setLoading', false)
			   commit('setPageload', false)
			}).catch(err => { commit('setLoading', false); commit('setPageload', false);console.log('console err list  ', err) })
      },

	
    /* Notification Listing*/
    
     notifyListing ({ commit, dispatch, state }, payload) {
		if(payload.uid){ 
			axios.defaults.headers.common['Authorization'] =  'Bearer ' + localStorage.getItem('abittoken');
			axios.post(`${window.devendpoint}/firebase/users/getphonenotifylist`, {uid: payload.uid,phoneid: payload.phoneid}).then(function(res){
					//console.log('res.data getTopNotifylist',res.data[0]);
					if(res.data[0].rows === undefined && res.data[0].rows === null){  
						 state.notificationlist = [];
					}else {
						 state.notificationlist = res.data[0].rows;
					}
			}).catch(err => { }); 
		} 
	 },
	 //Alerts 
     addAlertsRemainder ({ commit, dispatch, state }, payload) {
		 		 
		 commit('setLoading', true)
		axios.defaults.headers.common['Authorization'] =  'Bearer ' + localStorage.getItem('abittoken');
        axios.post(`${window.devendpoint}/reminder/notifications/add-alertreminder`, payload , { headers: { 	'Content-Type': 'multipart/form-data' }   } ).then(dataset => {
           console.log('console add-alertreminder ', dataset)
           commit('setLoading', false)
           console.log('payload',payload)
           dispatch('listAlertsRemainder', {uid: state.user.uid,schedule_availability_id:  state.businessProfileInfo.id})
        }).catch(err => { commit('setLoading', false); console.log('console err add-alertreminder ', err); })
     },
     listAlertsRemainder ({ commit, state }, payload) {	
		commit('setPageload', true)
		var schedule_availability_id = payload.schedule_availability_id;
		var schedule_availability_type = payload.schedule_availability_type;
		if(schedule_availability_type == undefined || schedule_availability_type == "" || schedule_availability_type == null){
			schedule_availability_type = '';
		}
		if(schedule_availability_id == undefined || schedule_availability_id == "" || schedule_availability_id == null){
			schedule_availability_id = '';
		}
		axios.defaults.headers.common['Authorization'] =  'Bearer ' + localStorage.getItem('abittoken');
		axios.post(`${window.devendpoint}/firebase/users/getdaysettings`,{ uid: state.user.uid,  ScheduleCalcID: schedule_availability_id, ScheduleCalcType:schedule_availability_type }).then(function(response){
			commit('setPageload', false)
			if(response.data.error === false){							
				state.alertsevents = response.data.rows
				state.alertlist = response.data.alertlist
			}
		}).catch(err => {
			commit('setPageload', false)
			console.log('catch',err)
		});  
     },
     addPmRemainder ({ commit, dispatch, state }, payload) {
		 commit('setLoading', true)
		axios.defaults.headers.common['Authorization'] =  'Bearer ' + localStorage.getItem('abittoken');
        axios.post(`${window.devendpoint}/reminder/notifications/add-pm-reminder`, payload , { headers: { 	'Content-Type': 'multipart/form-data' }   } ).then(dataset => {
           console.log('console addRemainder ', dataset)
           commit('setLoading', false)
           dispatch('listRemainder', {uid: state.user.uid })
        }).catch(err => { commit('setLoading', false); console.log('console err addRemainder ', err); })
     },
     addRemainder ({ commit, dispatch, state }, payload) {
		 commit('setLoading', true)
		axios.defaults.headers.common['Authorization'] =  'Bearer ' + localStorage.getItem('abittoken');
        axios.post(`${window.devendpoint}/reminder/notifications/add-reminder`, payload , { headers: { 	'Content-Type': 'multipart/form-data' }   } ).then(dataset => {
           console.log('console addRemainder ', dataset)
           commit('setLoading', false)
           dispatch('listRemainder', {uid: state.user.uid })
        }).catch(err => { commit('setLoading', false); console.log('console err addRemainder ', err); })
     },
     listRemainder ({ commit, state }, payload) {
		 
		commit('setListLoading', true)
		axios.defaults.headers.common['Authorization'] =  'Bearer ' + localStorage.getItem('abittoken');
        axios.get(`${window.devendpoint}/reminder/notifications/list-reminder/${payload.uid}?type=${payload.type}`, payload).then(dataset => {
           //console.log('console listRemainder ', dataset.data.rows)
           commit('setListLoading', false)
           commit('setRemainders', dataset.data.rows)
        }).catch(err => { commit('setListLoading', false); console.log('console err listRemainder ', err) })
     },
     listRemainderbyPhone ({ commit, state }, payload) {
		 
		commit('setListLoading', true)
		axios.defaults.headers.common['Authorization'] =  'Bearer ' + localStorage.getItem('abittoken');
        axios.get(`${window.devendpoint}/reminder/notifications/list-phonereminder/${payload.uid}/${payload.phoneid}`, payload).then(dataset => {
           //console.log('console listRemainder ', dataset.data.rows)
           commit('setListLoading', false)
           commit('setRemainders', dataset.data.rows)
        }).catch(err => { commit('setListLoading', false); console.log('console err listRemainder ', err) })
     },
     deleteRemainder ({ commit, state }, payload) {
		axios.defaults.headers.common['Authorization'] =  'Bearer ' + localStorage.getItem('abittoken');
        axios.post(`${window.devendpoint}/reminder/notifications/deletereminder`, payload).then(dataset => {
           console.log('console deleteremainder ', dataset.data.msgid)
        }).catch(err => { console.log('console err deleteRemainder ', err) })
     },
     inactiveRemainder ({ commit, state }, payload) {
		axios.defaults.headers.common['Authorization'] =  'Bearer ' + localStorage.getItem('abittoken');
        axios.post(`${window.devendpoint}/reminder/notifications/inactivereminder`, payload).then(dataset => {
           console.log('console inactiveRemainder ', dataset.data.msgid)
        }).catch(err => { console.log('console err inactiveRemainder ', err) })
     },
     copyRemainder ({ commit, dispatch, state }, payload) {
		axios.defaults.headers.common['Authorization'] =  'Bearer ' + localStorage.getItem('abittoken');
        axios.post(`${window.devendpoint}/reminder/notifications/copy-reminder`, payload).then(dataset => {
		   dispatch('listRemainder', {uid: state.user.uid })
           console.log('console copyRemainder ', dataset.data.msgid)
        }).catch(err => { console.log('console err copyRemainder ', err) })
     },
     
     
     /* Template label & messages */
	gettemplatelabel({ commit, state }, payload)  {
		console.log('state.user',state.user)
		if(state.user  != null && state.user != undefined && state.user  != ''){
			var uid = state.user.uid;
			var catid = 'all';
			axios.defaults.headers.common['Authorization'] =  'Bearer ' + localStorage.getItem('abittoken');
			axios.get(`${window.devendpoint}/reminder/templates/listlabel/${uid}/${catid}`).then(function(response){	
				console.log('response.data.rows',response.data.rows);			
					state.templatelabel = response.data.rows;
			}).catch(err => { 
					console.log('get templatelabel err',err);
			});
		}
	},
	gettemplatemessages({ commit, state }, payload)  {
		if(state.user  != null && state.user != undefined && state.user  != ''){
			var uid = state.user.uid;
			if(payload.cid != undefined)	var templatecatid = payload.cid;
			if(templatecatid == '' || templatecatid == null || templatecatid == undefined){
				var catid = 'all';
			}else{
				var catid = templatecatid;
			}
			axios.defaults.headers.common['Authorization'] =  'Bearer ' + localStorage.getItem('abittoken');
			axios.get(`${window.devendpoint}/reminder/templates/listmessage/${uid}/${catid}`).then(function(response){				
					state.templatemessages = response.data.rows;
			}).catch(err => { 
					console.log('get templatemessages err',err);
			});
		}
	},
	//TaskRouters
	setworkspace:(context) => {
      	  context.commit('getworkspacefulldetails');
    },upselectedworkspace:(context,payload) => {
      	  context.commit('upselectedworkspace',payload);
    },setactivities:(context) => {
      	  context.commit('getactivities');
    },setworkerlist:(context) => {
      	  context.commit('getworkerlist');
    },
    //Private Numbers
    setprivatenumbers:(context) => {
      	  context.commit('getprivatenumbers');
    },purchaseprivatenumber:(context) => {
      	  context.commit('purchaseprivatenumber'); //Auto Buy Any one Number
    },buyselectedprivatenumber:(context,payload) => {
      	  context.commit('buyselectedprivatenumber',payload); //Selected Number - Buy new Number
    },upselectedprivatenumbers:(context,payload) => {
      	  context.commit('upselectedprivatenumbers',payload);
    },searchprivatenumber:(context,payload) => {
      	  context.commit('searchprivatenumber',payload); //search Number List
    },
    //Entity group
    setEntViewslist:(context,payload) => {
      	  context.commit('getEntViewslist',payload);
    },     
    //Trackingterms TypeDefine tables
    setTTTableslist:(context,payload) => {
      	  context.commit('getTTTableslist',payload);
    }, 
	 //TT - Groups
    setTTGroupslist:(context,payload) => {
      	  context.commit('getTTGroupslist',payload);
    }, 
	 //TT - platformlist
    setplatformlist:(context,payload) => {
      	  context.commit('getplatformlist',payload);
    }, 
    //Actoins
    setActionlist:(context,payload) => {
      	  context.commit('getActionlist',payload);
    }, 
    //Contacts
    getcontacts:(context,payload) => {
      	  context.commit('getContactlist',payload);
    }, 
    getgroups:(context) => {
      	  context.commit('getGrouplist');
    },
    setGroupContactlist:(context,payload) => {
		  context.commit('getGroupContactlist',payload);
	}, 
    //GoogleMaps
    setgMapInputLocation:(context) => {
      	  context.commit('getgMapInputLocation');
    },resetgMapInputLocation:(context) => {
		 context.commit('resetgMapInputLocation');
	},
	//Portfolio
	setPortfolio: (context) => {
		context.commit('getPortfolio');
	},
	
	//Stories
	setstories: (context) => {
		context.commit('getstories');
	},
	editstories ({ commit, dispatch, state }, payload) {
		if(state.user  != null && state.user != undefined && state.user  != ''){	 
			 var uid =state.user.uid;
			 if(uid){	
				 var id = payload.id;
				 store.commit('setPageload', true)	 
				 axios.get(`${window.endpoint}/firebase/users/coverpagelist/${uid}/${id}`) 
				 .then((res) => {				 
					 store.commit('setPageload', false)
					 state.coverpage = res.data.rows[0];
					 //console.log('res.data.rows.background_image',res.data.rows.background_image)
					 state.coverfiles = res.data.rows[0].background_image ;	
				}).catch(err => {
					store.commit('setPageload', false);	console.log(err); 
				});
			 }
		  }
     },
	editpagelayout ({ commit, dispatch, state }, payload) {
		if(state.user  != null && state.user != undefined && state.user  != ''){	 
			 var uid =state.user.uid;
			 if(uid){	
				 var id = payload.id;
				 store.commit('setPageload', true)	 
				 axios.get(`${window.endpoint}/firebase/users/storypagelist/${uid}/${id}`) 
				 .then((res) => {	
					 console.log('res.data',res.data)			 
					 store.commit('setPageload', false)
					 if(res.data.rows !== undefined && res.data.rows !== null && res.data.rows !== '' && res.data.rows.length !== 0 ){
						 state.storypage_elements = res.data.rows[0];
						 state.storypagefiles = res.data.rows[0].background_image ;
					 }	
				}).catch(err => {
					store.commit('setPageload', false);	console.log(err); 
				});
			 }
		  }
     },
	editendpage ({ commit, dispatch, state }, payload) {
		if(state.user  != null && state.user != undefined && state.user  != ''){	 
			 var uid =state.user.uid;
			 if(uid){	
				 var id = payload.id;
				 store.commit('setPageload', true)	 
				 axios.get(`${window.endpoint}/firebase/users/endpagelist/${uid}/${id}`) 
				 .then((res) => {	
					 console.log('res.data',res.data)			 
					 store.commit('setPageload', false)
					 if(res.data.rows !== undefined && res.data.rows !== null && res.data.rows !== '' && res.data.rows.length !== 0 ){
						state.endpage = res.data.rows[0];
					}
				}).catch(err => {
					store.commit('setPageload', false);	console.log(err); 
				});
			 }
		  }
     },
	
	//Mothers day
	setmotherscelebrate: (context) => {
		context.commit('getmotherscelebrate');
	},
	//Box services
	setboxservice: (context) => {
		context.commit('getboxservice');
	},
	//Knowledge services
	setks: (context) => {
		context.commit('getks');
	},
	setdayks: (context, payload) => {
		context.commit('getdayks', payload);
	},
	//Pages
	setpages: (context) => {
		context.commit('getpages');
	},
	//codebook
	setcodebook: (context) => {
		context.commit('getcodebook');
    },
	//getemailaccount
	setemailaccount: (context) => {
		context.commit('getemailaccount');
    },
	//trackingterms
	settrackingterms: (context) => {
		context.commit('gettrackingterms');
    },
	//authkeylist
	setauthkeylist: (context) => {
		context.commit('getauthkeylist');
    },
	//entitylist
	setentitylist: (context) => {
		context.commit('getentitylist');
    },
	//entitylist - table by user
	setusertableentitylist: (context,payload) => {
		context.commit('getusertableentitylist',payload);
    },
	//jupyter
	setjupyterfiles: (context) => {
		context.commit('getjupyterfiles');
    },
	//Blogs
	setblogs: (context) => {
		context.commit('getblogs');
	},
	setpagesblogs: (context,payload) => {
		context.commit('getpagesblogs', payload);
	},
	setblogcategory: (context,payload) => {
		context.commit('getblogcategory',payload);
	},
	setblogsubcategory: (context,payload) => {
		context.commit('getblogsubcategory',payload);
	},
	//ME MOM POP Category
	setmemomcategory: (context,payload) => {
		context.commit('getmemomcategory',payload);
	},
	setmemomsubcategory: (context,payload) => {
		context.commit('getmemomsubcategory',payload);
	},
	setcomments: (context,payload) => {
		context.commit('getcomments',payload);
	},
	approvecomment ({ commit, dispatch, state }, payload) {
		commit('setPageload', true)
		//axios.defaults.headers.common['Authorization'] =  'Bearer ' + localStorage.getItem('abittoken');
        axios.post(`${window.endpoint}/firebase/users/approve-comments`, payload).then(dataset => {
			//commit('setPageload', false)
			setTimeout(function () { dispatch('setcomments', {blogid: payload.blogid })  }, 2000)
        }).catch(err => { commit('setPageload', false);  })
    },
	editTemplate ({ commit, dispatch, state }, payload) {
		if(state.user  != null && state.user != undefined && state.user  != ''){	 
			 var uid =state.user.uid;
			 if(uid){	
				 var id = payload.id;
				 store.commit('setPageload', true)	 
				 //axios.get(`${window.endpoint}/firebase/users/bloglist/${uid}/${id}`) 
				 axios.post(`${window.endpoint}/firebase/users/template_cms_list`, { id: id, uid: uid}) 
				 .then((res) => {				 
					 console.log('res',res)
					 store.commit('setPageload', false)
					 state.addblogitem =  res.data.rows[0]  ;
					 //state.addblogitem = JSON.parse(JSON.stringify(res.data.rows[0])) ;
					 state.addblogfiles = res.data.rows[0].uploadedfiles
					 if(res.data.rows[0].blog_panel === undefined){
						 state.addblogitem.blog_panel = [{ panel: res.data.rows[0].blog_description }];		
					 }
					 /*else{
						 state.addblogitem.blog_panel = JSON.parse(JSON.stringify(res.data.rows[0].blog_panel));
					 }*/
					 
					 if(res.data.rows[0].projectid){
					    state.selprojectid = res.data.rows[0].projectid;
					  }else{
					    state.selprojectid = null; 
					   
					  } 
					// state.editorContent = res.data.rows[0].blog_panel ;		
				}).catch(err => {
					store.commit('setPageload', false);	console.log(err); 
				});
			 }
		  }
     },
	 editTTGroups ({ commit, dispatch, state }, payload) {
		if(state.user  != null && state.user != undefined && state.user  != ''){	 
			 var uid =state.user.uid;
			 if(uid){	
				 var id = payload.id;
				 store.commit('setPageload', true)	  
				 axios.post(`${window.endpoint}/firebase/users/gettrackinggrouplists`, { uid: uid,id: id}) 
				 .then((res) => {				 
					 store.commit('setPageload', false)	  
					 state.TTGroupsselected = res.data.rows ; 	 
				}).catch(err => {
					store.commit('setPageload', false);	console.log(err); 
				});
			 }
		  }
     },
     editTrackingterms ({ commit, dispatch, state }, payload) {
		if(state.user  != null && state.user != undefined && state.user  != ''){	 
			 var uid =state.user.uid;
			 if(uid){	
				 var id = payload.id;
				 store.commit('setPageload', true)	  
				 axios.post(`${window.endpoint}/firebase/users/gettrackingterms`, { uid: uid,id: id}) 
				 .then((res) => {				 
					 store.commit('setPageload', false)
					 state.addtrackingterms = res.data.rows[0] ; 	 
					 state.viewtrackingterms = res.data.rows[0] ; 	 
				}).catch(err => {
					store.commit('setPageload', false);	console.log(err); 
				});
			 }
		  }
     },   
     editEntity ({ commit, dispatch, state }, payload) {
		if(state.user  != null && state.user != undefined && state.user  != ''){	 
			 var uid =state.user.uid;
			 if(uid){	
				 var id = payload.id;
				 store.commit('setPageload', true)	  
				 axios.post(`${window.endpoint}/firebase/users/getentities`, { uid: uid,id: id}) 
				 .then((res) => {				 
					 store.commit('setPageload', false)
					 state.addentity = res.data.rows[0] ; 	 
				}).catch(err => {
					store.commit('setPageload', false);	console.log(err); 
				});
			 }
		  }
     },  
     editCodeFile ({ commit, dispatch, state }, payload) {
		if(state.user  != null && state.user != undefined && state.user  != ''){	 
			 var uid =state.user.uid;
			 if(uid){	
				 var id = payload.id;
				 store.commit('setPageload', true)	  
				 axios.post(`${window.endpoint}/firebase/users/getcodebookfiles`, { uid: uid,id: id}) 
				 .then((res) => {				 
					 store.commit('setPageload', false)
					 state.addcodebook = res.data.rows[0] ; 	
					 var content = res.data.rows[0].filecontent;
					 state.addcodebook.filecontent = content.replace(/&quot;/g, "'"); 	
				}).catch(err => {
					store.commit('setPageload', false);	console.log(err); 
				});
			 }
		  }
     },   
    editBlogs ({ commit, dispatch, state }, payload) {
		return new Promise((resolve, reject) => {								   
		if(state.user  != null && state.user != undefined && state.user  != ''){	 
			 var uid =state.user.uid;
			 if(uid){	
				 var id = payload.id;
				 store.commit('setPageload', true)	 
				 if(state.user.Type=='Subaccount'){
					var UserId = state.user.primaryuid
				 }else{
					var UserId = state.user.uid
				 }	
				 //axios.get(`${window.endpoint}/firebase/users/bloglist/${uid}/${id}`) 
				 axios.post(`${window.endpoint}/firebase/users/bloglist`, { useremail: state.user.emailaddress ,uid: UserId,id: id}) 
				 .then((res) => {
					 state.cmsroom='cms'+id;
					 store.commit('setPageload', false)
					 dispatch('listselCat',{uid:UserId,siteid:res.data.rows[0].abitcmssite_id})
					 
					 state.addblogitem = res.data.rows[0] ;
					 state.addblogfiles = res.data.rows[0].uploadedfiles
					 //state.addblogcodefiles = res.data.rows[0].uploadedcodefiles    
					state.addblogcodefiles = [] 			  
					 if(res.data.rows[0].blog_panel === undefined){
						 state.addblogitem.blog_panel = [{ panel: res.data.rows[0].blog_description }];		
					 }	
					 
					if(state.addblogitem.code_panel.length > 0 && state.addblogitem.code_panel !== undefined){
						for( var c =0; c < state.addblogitem.code_panel.length; c++){ 
														
						/*** If Snippets / Content for Codepanels  **/
						state.addblogitem.code_panel[c].filecontent = state.addblogitem.code_panel[c].filecontent.replace(/&quot;/g, "'"); 
						state.addblogitem.code_panel[c].description = state.addblogitem.code_panel[c].description.replace(/&quot;/g, "'"); 
						state.addblogitem.code_panel[c].command = state.addblogitem.code_panel[c].command.replace(/&quot;/g, "'"); 
						
						/*** If Ipmorted for Codepanels  **/
							
						}
					}
	 
					resolve();
	  
					 if(res.data.rows[0].projectid){
					    state.selprojectid = res.data.rows[0].projectid;
					  }else{
					    state.selprojectid = null; 
					   
					  } 
					// state.editorContent = res.data.rows[0].blog_panel ;		
				}).catch(err => {
					store.commit('setPageload', false);	console.log(err); 
					resolve();
				});
			 }
		  }
	  })
     },
    editPages ({ commit, dispatch, state }, payload) {
		if(state.user  != null && state.user != undefined && state.user  != ''){	 
			 var uid =state.user.uid;
			 if(uid){	
				 var id = payload.id;
				 store.commit('setPageload', true)	 
				 axios.post(`${window.endpoint}/firebase/users/pagelist`, {useremail: state.user.emailaddress , uid: uid,id: id}) 
				 .then((res) => {				 
					 store.commit('setPageload', false)
					 state.addpageitem = res.data.rows[0] ;
					 state.addpagefiles = res.data.rows[0].uploadedfiles ;
					 if(res.data.rows[0].pagerule === undefined){
						 state.addpageitem.pagerule =   res.data.rows[0].pagerule ;		
					 }	
				}).catch(err => {
					store.commit('setPageload', false);	console.log(err); 
				});
			 }
		  }
     },
    storageList ({ commit, dispatch, state }, payload) {
		if(state.user  != null && state.user != undefined && state.user  != ''){	 
			 var uid =state.user.uid;
			 if(uid){	
				// store.commit('setPageload', true)	 
				 //axios.get(`${window.endpoint}/firebase/users/mediastoragelist/${uid}`) 
				// axios.get(`${window.endpoint}/securereminder/liststore/${uid}`) 
				axios.get(`${window.endpoint}/securereminder/listamazon/${uid}`) 
				 .then((res) => {				 
					 store.commit('setPageload', false)
					 state.StorageList = res.data.rows;	
						var arrFoo = [];
						for (var i = 0; i < res.data.rows.length; i++) { 
							// Do stuff with found object. E.g. put it into an array:
							arrFoo.push(res.data.rows[i]['name']);
						}
						state.StorageSelectnameList = arrFoo
						state.loading = false;	
	
				}).catch(err => {
					store.commit('setPageload', false);	console.log(err); 
				});
			 }
		  }
     },
     //Todos
	setTodolistid: (context,tid) => {
		  context.commit('setTodolistid',tid);
	},setTodolists: (context,todolists) => {
		  context.commit('setTodolists',todolists);
	},editTodos: (context,todos) => {
		  context.commit('editTodos',todos);
	},setTodos: (context,todos) => {
		  context.commit('setTodos',todos);
	},setTodoBacklog: (context,todos) => {
		  context.commit('setTodoBacklog',todos);
	},setMenuList: (context,listtype) => {
		  context.commit('setMenuList',listtype);
	},setTodoProjectData: (context,listtype) => {
		  context.commit('setTodoProjectData',listtype);
	},setTodoProjects: (context,listtype) => {
		  context.commit('setTodoProjects',listtype);
	},setProjectLoglistings: (context,listtype) => {
		  context.commit('setProjectLoglistings',listtype);
	},setConfigStates: (context,listtype) => {
		  context.commit('setConfigStates',listtype);
	},setConfigStatus: (context,listtype) => {
		  context.commit('setConfigStatus',listtype);
	},setTodolistRecentlog: (context,todo) => {
		  context.commit('setTodolistRecentlog',todo);
	},
	
	//Create Meetings - oad All Calendar here
	setlistCalcProfile ({ commit, dispatch, state }, payload) {
		
		console.log('store setlistCalcProfile',payload);
	    if(!state.businessProfileSelectedForce){
			state.businessProfileInfoList = [];
			state.businessProfileInfo = [];
			state.businessProfileSelected = "";
			dispatch('getCalendarMeetings',{mid:'', selectedEvent: {}})
		}
		var uid =state.user.uid;
		if(uid){
			store.commit('setPageload', true);
			axios.defaults.headers.common['Authorization'] =  'Bearer ' + localStorage.getItem('abittoken');
			axios.post(`${window.devendpoint}/firebase/users/getschedulecalllist`,{ uid: uid , type : 'Schedule-availability' } ).then(response => {
			   //console.log('console addRemainder ', dataset)
				commit('setPageload', false)
				
				
				if(response.data.error === false){							
					//vm.BProfileInfo = response.data.rows					
					state.businessProfileInfoList = response.data.rows
						
					if(response.data.rows.length > 0 && response.data.rows[0] !== undefined && response.data.rows[0].id !== undefined && response.data.rows[0].id !== '' && response.data.rows[0].id !== null){
						
						if(state.businessProfileSelectedForce){
							state.businessProfileSelectedForce = false;
						}else{
							state.businessProfileInfo = response.data.rows[0]
							state.businessProfileSelected = response.data.rows[0].id; 
							dispatch('getCalendarMeetings',{mid:state.businessProfileSelected, selectedEvent: {}}) 
						}
					}else{
						
						 state.businessProfileInfoList = [];
						 state.businessProfileInfo = [];
						 state.businessProfileSelected = "";
						 dispatch('getCalendarMeetings',{mid:'', selectedEvent: {}})
					}
				}
				
			}).catch(err => { 
				commit('setPageload', false); console.log('console err setlistCalcProfile ', err); 
			})
			
		}			
     },	
    
  },
  getters: {
    isAuthenticated (state) {
      return state.user !== null && state.user !== undefined
    },
    alertsevents: state => state.alertsevents,
    alertlist: state => state.alertlist,
    remainder: state => state.remainder,
    templatelabel: state => state.templatelabel,
    templatemessages: state => state.templatemessages,
    subworkerlist: state => state.subworkerlist,
    privateNumbers: state => state.privateNumbers,
    getcontacts: state => state.listcontacts,
    //getgroups: state => state.groups,
    //getgroups(state){ 
		//return state.groups.slice(0).sort((a, b) => ((a.favorite_status) ? 1 : 0) < ((b.favorite_status) ? 1 : 0) ? 1 : -1 );
	//},
    getselectedgroupid: state => state.selectedGroups,
    phonenumberlist: state => state.phonenumberlist, // Pvt Searched Number list to Buy
	getWorkspaces(state){
			return  state.workspaces;
	},
	
	//Todos
	getTodolistid: state => {
      return state.todotitle_id;
    },getTodos: state => {
      return state.todos;
    },getTodoProjects: state => {
      return state.todoprojects;
    },
    
    
  }
})
/* dev check git 2*/



// WEBPACK FOOTER //
// ./src/store/index.js